/* eslint-disable */
/* tslint:disable */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
};

export type OrderAppAddress = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  cityArea: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  country: OrderAppCountryDisplay;
  countryArea: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  streetAddress1: Scalars['String']['output'];
  streetAddress2: Scalars['String']['output'];
};

export type OrderAppAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  cityArea?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<OrderAppCountryCode>;
  countryArea?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<OrderAppMetadataInput>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  skipValidation?: InputMaybe<Scalars['Boolean']['input']>;
  streetAddress1?: InputMaybe<Scalars['String']['input']>;
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAppAttribute = {
  __typename?: 'Attribute';
  slug?: Maybe<Scalars['String']['output']>;
};

export type OrderAppAttributeValue = {
  __typename?: 'AttributeValue';
  name?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<OrderAppAttributeValueTranslation>;
};


export type OrderAppAttributeValueTranslationArgs = {
  languageCode: OrderAppLanguageCodeEnum;
};

export type OrderAppAttributeValueTranslation = {
  __typename?: 'AttributeValueTranslation';
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderAppBillingCountry = {
  __typename?: 'BillingCountry';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderAppCtaType =
  | 'NOTIFY'
  | 'NO_CTA'
  | 'ORDER'
  | 'PRE_ORDER';

export type OrderAppCategory = {
  __typename?: 'Category';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OrderAppChannel = {
  __typename?: 'Channel';
  currencyCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
};

export type OrderAppChannelConfig = {
  __typename?: 'ChannelConfig';
  defaultDeliveryMethod?: Maybe<Scalars['ID']['output']>;
  deliveryModes: Array<OrderAppDeliveryMode>;
};

export type OrderAppCheckout = {
  __typename?: 'Checkout';
  billingAddress?: Maybe<OrderAppAddress>;
  channel: OrderAppChannel;
  deliveryMethod?: Maybe<OrderAppDeliveryMethod>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  languageCode?: Maybe<Scalars['String']['output']>;
  lines?: Maybe<Array<OrderAppCheckoutLine>>;
  shippingAddress?: Maybe<OrderAppAddress>;
  user?: Maybe<OrderAppUser>;
};

export type OrderAppCheckoutAddressValidationRules = {
  checkFieldsFormat?: InputMaybe<Scalars['Boolean']['input']>;
  checkRequiredFields?: InputMaybe<Scalars['Boolean']['input']>;
  enableFieldsNormalization?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderAppCheckoutCreate = {
  __typename?: 'CheckoutCreate';
  checkout?: Maybe<OrderAppCheckoutCreateCheckout>;
  errors: Array<OrderAppError>;
};

export type OrderAppCheckoutCreateCheckout = {
  __typename?: 'CheckoutCreateCheckout';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  user?: Maybe<OrderAppCheckoutCreateUser>;
};

export type OrderAppCheckoutCreateInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAppCheckoutCreateUser = {
  __typename?: 'CheckoutCreateUser';
  email?: Maybe<Scalars['String']['output']>;
};

export type OrderAppCheckoutGwpInput = {
  doNotNeedGift: Scalars['Boolean']['input'];
  gwpProductId: Scalars['String']['input'];
  lineIdToRemove: Scalars['String']['input'];
};

export type OrderAppCheckoutGwpUpdateResult = {
  __typename?: 'CheckoutGwpUpdateResult';
  errors: Array<OrderAppError>;
};

export type OrderAppCheckoutLine = {
  __typename?: 'CheckoutLine';
  hasWarrantyExtension?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Array<OrderAppMetadataItem>>;
  quantity: Scalars['Int']['output'];
  requiresShipping: Scalars['Boolean']['output'];
  strapPackReference?: Maybe<Scalars['String']['output']>;
  strapReference?: Maybe<Scalars['String']['output']>;
  totalPrice: OrderAppTaxedMoney;
  undiscountedUnitPrice: OrderAppTaxedMoney;
  unitPrice: OrderAppTaxedMoney;
  variant: OrderAppProductVariant;
  warrantyExtensionDuration?: Maybe<Scalars['String']['output']>;
  warrantyExtensionId?: Maybe<Scalars['String']['output']>;
  watchLineId?: Maybe<Scalars['String']['output']>;
};

export type OrderAppCheckoutLineInput = {
  forceNewLine?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<OrderAppMetadataInput>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Strap pack input, required if we adding product type of Strap Pack */
  strapPackInput?: InputMaybe<OrderAppStrapPackInput>;
  /** Related strap products inputs */
  strapRelatedProducts?: InputMaybe<OrderAppStrapRelatedProductsInput>;
  variantId: Scalars['ID']['input'];
  /** Checkout line id of watch, required if we adding product type of Warranty */
  watchLineId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderAppCheckoutLinesAddResult = {
  __typename?: 'CheckoutLinesAddResult';
  errors: Array<OrderAppError>;
  requiresSocialClubTerms?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderAppCheckoutLinesDeleteResult = {
  __typename?: 'CheckoutLinesDeleteResult';
  errors: Array<OrderAppError>;
  requiresSocialClubTerms?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderAppCheckoutShippingAddressUpdateResult = {
  __typename?: 'CheckoutShippingAddressUpdateResult';
  errors: Array<OrderAppError>;
};

export type OrderAppCheckoutValidationResult = {
  __typename?: 'CheckoutValidationResult';
  checkoutId: Scalars['ID']['output'];
  errors: Array<OrderAppError>;
  valid: Scalars['Boolean']['output'];
};

export type OrderAppCheckoutVoucherAddResult = {
  __typename?: 'CheckoutVoucherAddResult';
  checkout?: Maybe<OrderAppCheckout>;
  errors: Array<OrderAppError>;
};

export type OrderAppCheckoutVoucherDeleteResult = {
  __typename?: 'CheckoutVoucherDeleteResult';
  checkout?: Maybe<OrderAppCheckout>;
  errors: Array<OrderAppError>;
};

export type OrderAppCountryChannel = {
  __typename?: 'CountryChannel';
  channel: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OrderAppCountryCode =
  | 'AD'
  | 'AE'
  | 'AF'
  | 'AG'
  | 'AI'
  | 'AL'
  | 'AM'
  | 'AO'
  | 'AQ'
  | 'AR'
  | 'AS'
  | 'AT'
  | 'AU'
  | 'AW'
  | 'AX'
  | 'AZ'
  | 'BA'
  | 'BB'
  | 'BD'
  | 'BE'
  | 'BF'
  | 'BG'
  | 'BH'
  | 'BI'
  | 'BJ'
  | 'BL'
  | 'BM'
  | 'BN'
  | 'BO'
  | 'BQ'
  | 'BR'
  | 'BS'
  | 'BT'
  | 'BV'
  | 'BW'
  | 'BY'
  | 'BZ'
  | 'CA'
  | 'CC'
  | 'CD'
  | 'CF'
  | 'CG'
  | 'CH'
  | 'CI'
  | 'CK'
  | 'CL'
  | 'CM'
  | 'CN'
  | 'CO'
  | 'CR'
  | 'CU'
  | 'CV'
  | 'CW'
  | 'CX'
  | 'CY'
  | 'CZ'
  | 'DE'
  | 'DJ'
  | 'DK'
  | 'DM'
  | 'DO'
  | 'DZ'
  | 'EC'
  | 'EE'
  | 'EG'
  | 'EH'
  | 'ER'
  | 'ES'
  | 'ET'
  | 'EU'
  | 'FI'
  | 'FJ'
  | 'FK'
  | 'FM'
  | 'FO'
  | 'FR'
  | 'GA'
  | 'GB'
  | 'GD'
  | 'GE'
  | 'GF'
  | 'GG'
  | 'GH'
  | 'GI'
  | 'GL'
  | 'GM'
  | 'GN'
  | 'GP'
  | 'GQ'
  | 'GR'
  | 'GS'
  | 'GT'
  | 'GU'
  | 'GW'
  | 'GY'
  | 'HK'
  | 'HM'
  | 'HN'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'ID'
  | 'IE'
  | 'IL'
  | 'IM'
  | 'IN'
  | 'IO'
  | 'IQ'
  | 'IR'
  | 'IS'
  | 'IT'
  | 'JE'
  | 'JM'
  | 'JO'
  | 'JP'
  | 'KE'
  | 'KG'
  | 'KH'
  | 'KI'
  | 'KM'
  | 'KN'
  | 'KP'
  | 'KR'
  | 'KW'
  | 'KY'
  | 'KZ'
  | 'LA'
  | 'LB'
  | 'LC'
  | 'LI'
  | 'LK'
  | 'LR'
  | 'LS'
  | 'LT'
  | 'LU'
  | 'LV'
  | 'LY'
  | 'MA'
  | 'MC'
  | 'MD'
  | 'ME'
  | 'MF'
  | 'MG'
  | 'MH'
  | 'MK'
  | 'ML'
  | 'MM'
  | 'MN'
  | 'MO'
  | 'MP'
  | 'MQ'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MU'
  | 'MV'
  | 'MW'
  | 'MX'
  | 'MY'
  | 'MZ'
  | 'NA'
  | 'NC'
  | 'NE'
  | 'NF'
  | 'NG'
  | 'NI'
  | 'NL'
  | 'NO'
  | 'NP'
  | 'NR'
  | 'NU'
  | 'NZ'
  | 'OM'
  | 'PA'
  | 'PE'
  | 'PF'
  | 'PG'
  | 'PH'
  | 'PK'
  | 'PL'
  | 'PM'
  | 'PN'
  | 'PR'
  | 'PS'
  | 'PT'
  | 'PW'
  | 'PY'
  | 'QA'
  | 'RE'
  | 'RO'
  | 'RS'
  | 'RU'
  | 'RW'
  | 'SA'
  | 'SB'
  | 'SC'
  | 'SD'
  | 'SE'
  | 'SG'
  | 'SH'
  | 'SI'
  | 'SJ'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SR'
  | 'SS'
  | 'ST'
  | 'SV'
  | 'SX'
  | 'SY'
  | 'SZ'
  | 'TC'
  | 'TD'
  | 'TF'
  | 'TG'
  | 'TH'
  | 'TJ'
  | 'TK'
  | 'TL'
  | 'TM'
  | 'TN'
  | 'TO'
  | 'TR'
  | 'TT'
  | 'TV'
  | 'TW'
  | 'TZ'
  | 'UA'
  | 'UG'
  | 'UM'
  | 'US'
  | 'UY'
  | 'UZ'
  | 'VA'
  | 'VC'
  | 'VE'
  | 'VG'
  | 'VI'
  | 'VN'
  | 'VU'
  | 'WF'
  | 'WS'
  | 'YE'
  | 'YT'
  | 'ZA'
  | 'ZM'
  | 'ZW';

export type OrderAppCountryDisplay = {
  __typename?: 'CountryDisplay';
  code: Scalars['String']['output'];
  country: Scalars['String']['output'];
};

export type OrderAppDeleteMetadata = {
  __typename?: 'DeleteMetadata';
  errors: Array<OrderAppError>;
  item?: Maybe<OrderAppObjectWithMetadata>;
};

export type OrderAppDeliveryMethod = {
  __typename?: 'DeliveryMethod';
  id: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type OrderAppDeliveryMode =
  | 'BOUTIQUE_PICKUP'
  | 'HOME_DELIVERY';

export type OrderAppDeliveryModeUpdateResult = {
  __typename?: 'DeliveryModeUpdateResult';
  errors: Array<OrderAppError>;
};

export type OrderAppDisabledReasonCode =
  | 'CUSTOMIZED_GOOD'
  | 'GIFT_ITEM'
  | 'HISTORICAL_CERTIFICATE'
  | 'INVALID_LINE_STATUS'
  | 'INVALID_ORDER_STATUS'
  | 'OUT_OF_EU_SCOPE'
  | 'WINDOW_EXPIRED';

export type OrderAppDiscountValueType =
  | 'FIXED'
  | 'PERCENTAGE';

export type OrderAppDiscountValueTypeEnum =
  | 'FIXED'
  | 'PERCENTAGE';

export type OrderAppDraftOrder = {
  __typename?: 'DraftOrder';
  businessId: Scalars['ID']['output'];
  channel: OrderAppChannel;
  id: Scalars['ID']['output'];
};

export type OrderAppDraftOrderCompleteResult = {
  __typename?: 'DraftOrderCompleteResult';
  errors: Array<OrderAppError>;
  order?: Maybe<OrderAppOrder>;
};

export type OrderAppDraftOrderCreateInput = {
  billingAddress?: InputMaybe<OrderAppAddressInput>;
  brand?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['ID']['input'];
  shippingAddress?: InputMaybe<OrderAppAddressInput>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAppDraftOrderCreateResult = {
  __typename?: 'DraftOrderCreateResult';
  errors: Array<OrderAppError>;
  order?: Maybe<OrderAppDraftOrder>;
};

export type OrderAppDynamicSettingsEnum =
  | 'CAPTURE_FAIL_MAILING_LIST'
  | 'PAY_PER_LINK_TOKEN_TIME_TO_LIVE';

/** The value field has to be a json converted to a string */
export type OrderAppEditSettingInput = {
  name: OrderAppDynamicSettingsEnum;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAppEngravingCoordinates = {
  x1: Scalars['Float']['input'];
  x2: Scalars['Float']['input'];
  y1: Scalars['Float']['input'];
  y2: Scalars['Float']['input'];
};

export type OrderAppEngravingInfoInput = {
  coordinates: OrderAppEngravingCoordinates;
  size: OrderAppEngravingSizeEnum;
  style: OrderAppEngravingStyleEnum;
  text: Scalars['String']['input'];
  type: OrderAppEngravingTypeEnum;
};

export type OrderAppEngravingSizeEnum =
  | 'L'
  | 'M';

export type OrderAppEngravingStyleEnum =
  | 'BLOCK'
  | 'CURSIVE';

export type OrderAppEngravingTypeEnum =
  | 'DATE'
  | 'INITIALS'
  | 'MESSAGE';

export type OrderAppError = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  context?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type OrderAppGuestContextInput = {
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};

export type OrderAppGuestLookupInput = {
  businessId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};

export type OrderAppGwpProduct = {
  __typename?: 'GwpProduct';
  available_quantity: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  product_type_slug: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  threshhold: Scalars['String']['output'];
  thumbnail_alt?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
};

export type OrderAppIdOnlyOrder = {
  __typename?: 'IdOnlyOrder';
  id: Scalars['ID']['output'];
};

export type OrderAppImage = {
  __typename?: 'Image';
  alt?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type OrderAppInvitationMethod =
  | 'MAIL'
  | 'SMS';

export type OrderAppLanguageCodeEnum =
  | 'DE'
  | 'EN_GB'
  | 'EN_US'
  | 'ES'
  | 'FR'
  | 'IT'
  | 'JA'
  | 'KO'
  | 'PT'
  | 'RU'
  | 'ZH_HANT'
  | 'ZH_HANT_TW';

export type OrderAppMarketPreOrderConfigInput = {
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableTo?: InputMaybe<Scalars['DateTime']['input']>;
  dedicatedStock?: InputMaybe<Scalars['Int']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  depositPercentage?: InputMaybe<Scalars['Int']['input']>;
  forcePreOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isInfiniteStock?: InputMaybe<Scalars['Boolean']['input']>;
  market: Scalars['String']['input'];
  notifyMe?: InputMaybe<Scalars['Boolean']['input']>;
  preOrder?: InputMaybe<OrderAppPreOrderConfigEnum>;
};

export type OrderAppMarketSellable = {
  __typename?: 'MarketSellable';
  market: Scalars['String']['output'];
  sellable?: Maybe<Scalars['Boolean']['output']>;
  sellingType?: Maybe<OrderAppSellingTypeEnum>;
};

export type OrderAppMarketVisible = {
  __typename?: 'MarketVisible';
  market: Scalars['String']['output'];
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderAppMetadataInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type OrderAppMetadataItem = {
  __typename?: 'MetadataItem';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OrderAppMoney = {
  __typename?: 'Money';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type OrderAppMutation = {
  __typename?: 'Mutation';
  checkoutCreate?: Maybe<OrderAppCheckoutCreate>;
  checkoutLinesAdd: OrderAppCheckoutLinesAddResult;
  checkoutLinesDelete: OrderAppCheckoutLinesDeleteResult;
  checkoutShippingAddressUpdate: OrderAppCheckoutShippingAddressUpdateResult;
  checkoutVoucherAdd: OrderAppCheckoutVoucherAddResult;
  checkoutVoucherDelete: OrderAppCheckoutVoucherDeleteResult;
  deleteMetadata: OrderAppDeleteMetadata;
  deliveryModeUpdate: OrderAppDeliveryModeUpdateResult;
  draftOrderComplete: OrderAppDraftOrderCompleteResult;
  draftOrderCreate: OrderAppDraftOrderCreateResult;
  editSetting: OrderAppSettingResult;
  gwpCheckoutUpdate: OrderAppCheckoutGwpUpdateResult;
  gwpOrderUpdate: OrderAppOrderGwpUpdateResult;
  offlinePaymentConfirm: OrderAppOfflinePaymentConfirmResult;
  offlinePaymentEmailDetails: OrderAppOfflinePaymentEmailResult;
  offlinePaymentToggle: OrderAppOfflinePaymentToggleResult;
  orderAbandon: OrderAppOrderAbandonResult;
  orderCancel: OrderAppOrderCancelResult;
  orderCreate: OrderAppOrderCreateResult;
  orderDiscountAdd: OrderAppOrderDiscountAddResult;
  orderFreeShippingAdd: OrderAppOrderFreeShippingAddResult;
  orderGenerateBusinessId: OrderAppOrderGenerateBusinessIdResult;
  orderGenerateInvoice: OrderAppOrderGenerateInvoiceResult;
  orderLineDelete: OrderAppOrderLineDeleteResult;
  orderLineDiscountRemove: OrderAppOrderLineDiscountRemove;
  orderLineDiscountUpdate: OrderAppOrderLineDiscountUpdateResult;
  orderLinesCreate: OrderAppOrderLinesCreateResult;
  orderReturnCancel?: Maybe<OrderAppOrderReturnCreate>;
  orderReturnCreate?: Maybe<OrderAppOrderReturnCreate>;
  orderReturnReject?: Maybe<OrderAppOrderReturnRejectResult>;
  orderSendPaymentInvitation: OrderAppOrderSendPaymentInvitationResult;
  orderShippingAddressUpdate: OrderAppOrderShippingAddressUpdateResult;
  orderUpdateClientDetails: OrderAppOrderUpdateClientDetailsResult;
  orderVoucherAdd: OrderAppOrderVoucherAddResult;
  orderVoucherDelete: OrderAppOrderVoucherDeleteResult;
  paymentCaptureRetry: OrderAppPaymentCaptureRetryResult;
  productVariantBulkUpdate: OrderAppProductVariantBulkUpdateResult;
  productVariantUpdate: OrderAppProductVariantUpdateResult;
  refundCreate: OrderAppRefundCreateResult;
  rerouteFulfillmentLocation: OrderAppRerouteFulfillmentLocationResult;
  resendReturnLabel: OrderAppResendReturnLabelResponse;
  sendInvoice: OrderAppSendInvoiceResponse;
  shippingUpdate: OrderAppShippingUpdateResult;
  subscriptionUpdate: OrderAppSubscriptionUpdateResult;
  updateEngravingInfo: OrderAppUpdateEngravingInfoResult;
  updateMetadata: OrderAppUpdateMetadataResult;
  withdrawalSubmit: OrderAppWithdrawalSubmitResult;
};


export type OrderAppMutationCheckoutCreateArgs = {
  input?: InputMaybe<OrderAppCheckoutCreateInput>;
};


export type OrderAppMutationCheckoutLinesAddArgs = {
  id: Scalars['ID']['input'];
  lines: Array<OrderAppCheckoutLineInput>;
  sellingType?: InputMaybe<OrderAppSellingTypeEnum>;
};


export type OrderAppMutationCheckoutLinesDeleteArgs = {
  id: Scalars['ID']['input'];
  linesIds: Array<Scalars['ID']['input']>;
  sellingType?: InputMaybe<OrderAppSellingTypeEnum>;
};


export type OrderAppMutationCheckoutShippingAddressUpdateArgs = {
  id: Scalars['ID']['input'];
  shippingAddress: OrderAppAddressInput;
  validationRules?: InputMaybe<OrderAppCheckoutAddressValidationRules>;
};


export type OrderAppMutationCheckoutVoucherAddArgs = {
  code: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type OrderAppMutationCheckoutVoucherDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationDeleteMetadataArgs = {
  id: Scalars['ID']['input'];
  keys: Array<Scalars['String']['input']>;
};


export type OrderAppMutationDeliveryModeUpdateArgs = {
  address?: InputMaybe<OrderAppAddressInput>;
  boutiqueExtReference?: InputMaybe<Scalars['String']['input']>;
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  deliveryMode: OrderAppDeliveryMode;
  draftOrderId?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
};


export type OrderAppMutationDraftOrderCompleteArgs = {
  id: Scalars['ID']['input'];
  source?: OrderAppOrderSource;
};


export type OrderAppMutationDraftOrderCreateArgs = {
  input: OrderAppDraftOrderCreateInput;
};


export type OrderAppMutationEditSettingArgs = {
  input?: InputMaybe<OrderAppEditSettingInput>;
};


export type OrderAppMutationGwpCheckoutUpdateArgs = {
  checkoutGwp: OrderAppCheckoutGwpInput;
  id: Scalars['ID']['input'];
};


export type OrderAppMutationGwpOrderUpdateArgs = {
  id: Scalars['ID']['input'];
  orderGwp: OrderAppOrderGwpInput;
};


export type OrderAppMutationOfflinePaymentConfirmArgs = {
  orderId: Scalars['ID']['input'];
};


export type OrderAppMutationOfflinePaymentEmailDetailsArgs = {
  orderId: Scalars['ID']['input'];
  paymentMethodType: OrderAppOfflinePaymentMethodTypeEnum;
};


export type OrderAppMutationOfflinePaymentToggleArgs = {
  isOfflinePayment: Scalars['Boolean']['input'];
  orderId: Scalars['ID']['input'];
};


export type OrderAppMutationOrderAbandonArgs = {
  checkoutId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};


export type OrderAppMutationOrderCancelArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reason: OrderAppOrderCancelReason;
  sendEmail?: Scalars['Boolean']['input'];
};


export type OrderAppMutationOrderCreateArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationOrderDiscountAddArgs = {
  force?: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  input: OrderAppOrderDiscountAddInput;
};


export type OrderAppMutationOrderFreeShippingAddArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationOrderGenerateBusinessIdArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationOrderGenerateInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationOrderLineDeleteArgs = {
  id: Scalars['ID']['input'];
  lineId: Scalars['ID']['input'];
};


export type OrderAppMutationOrderLineDiscountRemoveArgs = {
  orderLineId: Scalars['ID']['input'];
};


export type OrderAppMutationOrderLineDiscountUpdateArgs = {
  force?: Scalars['Boolean']['input'];
  input: OrderAppOrderLineDiscountUpdateInput;
  orderId: Scalars['ID']['input'];
  orderLineId: Scalars['ID']['input'];
};


export type OrderAppMutationOrderLinesCreateArgs = {
  id: Scalars['ID']['input'];
  lines: Array<OrderAppOrderLineInput>;
  sellingType?: InputMaybe<OrderAppSellingTypeEnum>;
};


export type OrderAppMutationOrderReturnCancelArgs = {
  fulfillment_bid: Scalars['String']['input'];
  orderLineIds: Array<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type OrderAppMutationOrderReturnCreateArgs = {
  input?: InputMaybe<Array<OrderAppOrderReturnItemLine>>;
  order_id: Scalars['ID']['input'];
};


export type OrderAppMutationOrderReturnRejectArgs = {
  fulfillment_bid: Scalars['String']['input'];
  input: OrderAppOrderReturnRejectItemsInput;
};


export type OrderAppMutationOrderSendPaymentInvitationArgs = {
  id: Scalars['ID']['input'];
  invitationMethod: OrderAppInvitationMethod;
};


export type OrderAppMutationOrderShippingAddressUpdateArgs = {
  id: Scalars['ID']['input'];
  shippingAddress: OrderAppAddressInput;
};


export type OrderAppMutationOrderUpdateClientDetailsArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationOrderVoucherAddArgs = {
  code: Scalars['String']['input'];
  force?: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type OrderAppMutationOrderVoucherDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationPaymentCaptureRetryArgs = {
  orderId: Scalars['ID']['input'];
};


export type OrderAppMutationProductVariantBulkUpdateArgs = {
  input: Array<OrderAppProductVariantInput>;
};


export type OrderAppMutationProductVariantUpdateArgs = {
  input: OrderAppProductVariantInput;
};


export type OrderAppMutationRefundCreateArgs = {
  order_id: Scalars['ID']['input'];
  refund_lines: Array<OrderAppRefundLine>;
  return_bid: Scalars['ID']['input'];
  silent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrderAppMutationRerouteFulfillmentLocationArgs = {
  omsFulfillmentId?: InputMaybe<Scalars['String']['input']>;
  omsOrderId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  rerouteToLocation?: InputMaybe<Scalars['String']['input']>;
};


export type OrderAppMutationResendReturnLabelArgs = {
  fulfillmentId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type OrderAppMutationSendInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppMutationShippingUpdateArgs = {
  id: Scalars['ID']['input'];
  type: OrderAppOrderShipping;
};


export type OrderAppMutationSubscriptionUpdateArgs = {
  id: Scalars['ID']['input'];
  status: OrderAppOrderSubscription;
};


export type OrderAppMutationUpdateEngravingInfoArgs = {
  id: Scalars['ID']['input'];
  input: OrderAppEngravingInfoInput;
  lineId: Scalars['ID']['input'];
};


export type OrderAppMutationUpdateMetadataArgs = {
  id: Scalars['ID']['input'];
  input: Array<OrderAppMetadataInput>;
};


export type OrderAppMutationWithdrawalSubmitArgs = {
  input: OrderAppWithdrawalSubmitInput;
};

export type OrderAppObjectWithMetadata = {
  __typename?: 'ObjectWithMetadata';
  metadata: Array<OrderAppMetadataItem>;
  metafield?: Maybe<Scalars['String']['output']>;
};


export type OrderAppObjectWithMetadataMetafieldArgs = {
  key: Scalars['String']['input'];
};

export type OrderAppOfflinePaymentConfirmResult = {
  __typename?: 'OfflinePaymentConfirmResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOfflinePaymentEmailResult = {
  __typename?: 'OfflinePaymentEmailResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOfflinePaymentMethodTypeEnum =
  | 'OFFLINE_BANKTRANSFER';

export type OrderAppOfflinePaymentToggleResult = {
  __typename?: 'OfflinePaymentToggleResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOrder = {
  __typename?: 'Order';
  billingAddress?: Maybe<OrderAppAddress>;
  businessId: Scalars['ID']['output'];
  channel: OrderAppChannel;
  discounts?: Maybe<Array<OrderAppOrderDiscount>>;
  hasEngraving: Scalars['Boolean']['output'];
  hasRefund: Scalars['Boolean']['output'];
  hasWarrantyExtension: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isValid: OrderAppOrderValidationStatus;
  lines?: Maybe<Array<OrderAppOrderLine>>;
  payPerLinkExpiration?: Maybe<Scalars['Float']['output']>;
  payPerLinkUrl?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<OrderAppOrderPayment>;
  paymentRequest: OrderAppPaymentRequestData;
  preOrderDeposit?: Maybe<OrderAppMoney>;
  preOrderDepositPercentage?: Maybe<Scalars['Int']['output']>;
  return?: Maybe<OrderAppOrderReturn>;
  shipping?: Maybe<OrderAppOrderShipping>;
  shippingAddress?: Maybe<OrderAppAddress>;
  source?: Maybe<OrderAppOrderSource>;
  status?: Maybe<OrderAppOrderStatus>;
  subscription?: Maybe<OrderAppOrderSubscription>;
  type?: Maybe<OrderAppOrderType>;
  user?: Maybe<OrderAppUser>;
  userEmail?: Maybe<Scalars['String']['output']>;
};


export type OrderAppOrderIsValidArgs = {
  newLines?: InputMaybe<Array<OrderAppOrderLineValidation>>;
};

export type OrderAppOrderAbandonResult = {
  __typename?: 'OrderAbandonResult';
  errors: Array<OrderAppError>;
  newBusinessId?: Maybe<Scalars['String']['output']>;
};

export type OrderAppOrderCancelReason =
  | 'CHANGE_OF_MIND'
  | 'FRAUD'
  | 'NO_REASON_GIVEN'
  | 'OTHERS'
  | 'PURCHASED_CHEAPER'
  | 'PURCHASED_DUPLICATE'
  | 'PURCHASED_ELSEWHERE'
  | 'PURCHASED_MISTAKE'
  | 'WRONG_COLOR'
  | 'WRONG_MODEL'
  | 'WRONG_SIZE';

export type OrderAppOrderCancelResult = {
  __typename?: 'OrderCancelResult';
  canceled: Scalars['Boolean']['output'];
  errors: Array<OrderAppError>;
  order?: Maybe<OrderAppOrder>;
};

export type OrderAppOrderCreateResult = {
  __typename?: 'OrderCreateResult';
  errors: Array<OrderAppError>;
  order?: Maybe<OrderAppOrder>;
};

export type OrderAppOrderDiscount = {
  __typename?: 'OrderDiscount';
  amount: OrderAppMoney;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  type: OrderAppOrderDiscountType;
  value: Scalars['Float']['output'];
  valueType: OrderAppDiscountValueType;
};

export type OrderAppOrderDiscountAddInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
  valueType: OrderAppDiscountValueType;
};

export type OrderAppOrderDiscountAddResult = {
  __typename?: 'OrderDiscountAddResult';
  errors: Array<OrderAppError>;
  order?: Maybe<OrderAppOrder>;
};

export type OrderAppOrderDiscountType =
  | 'MANUAL'
  | 'ORDER_PROMOTION'
  | 'PROMOTION'
  | 'SALE'
  | 'VOUCHER';

export type OrderAppOrderFreeShippingAddResult = {
  __typename?: 'OrderFreeShippingAddResult';
  errors: Array<OrderAppError>;
  order?: Maybe<OrderAppOrder>;
};

export type OrderAppOrderGenerateBusinessIdResult = {
  __typename?: 'OrderGenerateBusinessIdResult';
  businessId?: Maybe<Scalars['String']['output']>;
  errors: Array<OrderAppError>;
};

export type OrderAppOrderGenerateInvoiceResult = {
  __typename?: 'OrderGenerateInvoiceResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOrderGwpInput = {
  gwpProductId: Scalars['String']['input'];
  lineIdToRemove: Scalars['String']['input'];
};

export type OrderAppOrderGwpUpdateResult = {
  __typename?: 'OrderGwpUpdateResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOrderLine = {
  __typename?: 'OrderLine';
  discounts?: Maybe<Array<OrderAppOrderLineDiscount>>;
  hasWarrantyExtension?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Array<OrderAppMetadataItem>>;
  quantity: Scalars['Int']['output'];
  strapPackReference?: Maybe<Scalars['String']['output']>;
  strapReference?: Maybe<Scalars['String']['output']>;
  totalPrice: OrderAppTaxedMoney;
  undiscountedUnitPrice: OrderAppTaxedMoney;
  unitDiscount: OrderAppMoney;
  unitDiscountType?: Maybe<OrderAppDiscountValueType>;
  unitDiscountValue: Scalars['Float']['output'];
  unitPrice: OrderAppTaxedMoney;
  variant: OrderAppProductVariant;
  warrantyExtensionDuration?: Maybe<Scalars['String']['output']>;
  warrantyExtensionId?: Maybe<Scalars['String']['output']>;
  watchLineId?: Maybe<Scalars['String']['output']>;
};

export type OrderAppOrderLineDeleteResult = {
  __typename?: 'OrderLineDeleteResult';
  errors: Array<OrderAppError>;
  order?: Maybe<OrderAppOrder>;
};

export type OrderAppOrderLineDiscount = {
  __typename?: 'OrderLineDiscount';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  total: OrderAppMoney;
  translatedName?: Maybe<Scalars['String']['output']>;
  type: OrderAppOrderDiscountType;
  value: Scalars['Float']['output'];
  valueType: OrderAppDiscountValueType;
};

export type OrderAppOrderLineDiscountRemove = {
  __typename?: 'OrderLineDiscountRemove';
  errors: Array<OrderAppError>;
  order?: Maybe<OrderAppOrder>;
  orderLine?: Maybe<OrderAppOrderLine>;
};

export type OrderAppOrderLineDiscountUpdateInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
  valueType: OrderAppDiscountValueType;
};

export type OrderAppOrderLineDiscountUpdateResult = {
  __typename?: 'OrderLineDiscountUpdateResult';
  errors: Array<OrderAppError>;
  order?: Maybe<OrderAppOrder>;
  orderLine?: Maybe<OrderAppOrderLine>;
};

export type OrderAppOrderLineInput = {
  forceNewLine?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<OrderAppMetadataInput>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Strap pack input, required if we adding product type of Strap Pack */
  strapPackInput?: InputMaybe<OrderAppStrapPackInput>;
  /** Related strap products inputs */
  strapRelatedProducts?: InputMaybe<OrderAppStrapRelatedProductsInput>;
  variantId: Scalars['ID']['input'];
  /** Checkout line id of watch, required if we adding product type of Warranty */
  watchLineId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderAppOrderLineValidation = {
  productVariantId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type OrderAppOrderLinesCreateResult = {
  __typename?: 'OrderLinesCreateResult';
  errors: Array<OrderAppError>;
  order?: Maybe<OrderAppOrder>;
};

export type OrderAppOrderPayment =
  | 'PARTIAL_IN_VALIDATION'
  | 'PARTIAL_RECEIVED'
  | 'PARTIAL_REJECTED'
  | 'PREORDER_REJECTED';

export type OrderAppOrderReturn =
  | 'ACCEPTED'
  | 'CANCELLED'
  | 'IN_RETURN'
  | 'RECEIVED'
  | 'REGISTERED'
  | 'REJECTED';

export type OrderAppOrderReturnCreate = {
  __typename?: 'OrderReturnCreate';
  errors?: Maybe<Array<OrderAppError>>;
  order?: Maybe<OrderAppOrder>;
};

export type OrderAppOrderReturnItemLine = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  reason: OrderAppOrderReturnReason;
};

export type OrderAppOrderReturnReason =
  | 'BETTER_PRICE_ELSEWHERE'
  | 'DID_NOT_LIKE_COLOR'
  | 'DID_NOT_LIKE_SIZE'
  | 'DID_NOT_PAY'
  | 'LOST_PACKAGE'
  | 'OTHERS'
  | 'PURCHASED_AS_GIFT'
  | 'PURCHASED_DIFFERENT_BRAND'
  | 'REFUSE_PACKAGE'
  | 'STYLE_NOT_AS_EXPECTED';

export type OrderAppOrderReturnRejectItemInput = {
  order_line_id: Scalars['String']['input'];
};

export type OrderAppOrderReturnRejectItemsInput = {
  items: Array<OrderAppOrderReturnRejectItemInput>;
};

export type OrderAppOrderReturnRejectResult = {
  __typename?: 'OrderReturnRejectResult';
  errors?: Maybe<Array<OrderAppError>>;
};

export type OrderAppOrderSendPaymentInvitationResult = {
  __typename?: 'OrderSendPaymentInvitationResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOrderShipping =
  | 'BOUTIQUE'
  | 'CC'
  | 'HOME';

export type OrderAppOrderShippingAddressUpdateResult = {
  __typename?: 'OrderShippingAddressUpdateResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOrderSource =
  | 'BOUTIQUE'
  | 'FOR_GIFT'
  | 'GIFT'
  | 'PHONE'
  | 'RETAIL'
  | 'WEBSITE';

export type OrderAppOrderStatus =
  | 'ABANDONED'
  | 'CANCELLED'
  | 'COLLECTED'
  | 'CONFIRMED'
  | 'DRAFT'
  | 'IN_PREPARATION'
  | 'IN_VALIDATION'
  | 'PARTIALLY_IN_PREPARATION'
  | 'PARTIALLY_PAID'
  | 'PARTIALLY_READY_TO_SHIP'
  | 'PARTIALLY_RETURNED'
  | 'PARTIALLY_SHIPPED'
  | 'PARTIAL_PAYMENT_IN_VALIDATION'
  | 'PARTIAL_PAYMENT_RECEIVED'
  | 'PARTIAL_PAYMENT_REJECTED'
  | 'PENDING'
  | 'PREORDER_CANCELLED'
  | 'READY_FOR_COLLECTION'
  | 'READY_TO_SHIP'
  | 'REJECTED'
  | 'RETURNED'
  | 'RETURN_ACCEPTED'
  | 'RETURN_RECEIVED'
  | 'RETURN_REGISTERED'
  | 'RETURN_REJECTED'
  | 'SHIPPED';

export type OrderAppOrderSubscription =
  | 'CLOSED'
  | 'CONFIRMED'
  | 'PAYMENT_ERROR'
  | 'PENDING_CANCEL'
  | 'PENDING_ROTATION'
  | 'SUSPENDED'
  | 'VALIDATION';

export type OrderAppOrderType =
  | 'ORDER'
  | 'PRE_ORDER'
  | 'ROTATION'
  | 'SUBSCRIPTION'
  | 'WARRANTY_EXTENSION';

export type OrderAppOrderUpdateClientDetailsResult = {
  __typename?: 'OrderUpdateClientDetailsResult';
  errors: Array<OrderAppError>;
};

export type OrderAppOrderValidationResult = {
  __typename?: 'OrderValidationResult';
  errors: Array<OrderAppError>;
  id: Scalars['ID']['output'];
  valid: Scalars['Boolean']['output'];
};

export type OrderAppOrderValidationStatus = {
  __typename?: 'OrderValidationStatus';
  message?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type OrderAppOrderVoucherAddResult = {
  __typename?: 'OrderVoucherAddResult';
  errors: Array<OrderAppError>;
  order?: Maybe<OrderAppOrder>;
};

export type OrderAppOrderVoucherDeleteResult = {
  __typename?: 'OrderVoucherDeleteResult';
  errors: Array<OrderAppError>;
  order?: Maybe<OrderAppOrder>;
};

export type OrderAppPayPerLinkOrder = {
  __typename?: 'PayPerLinkOrder';
  businessId: Scalars['String']['output'];
  channel: OrderAppChannel;
  expirationTimestamp: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  lines: Array<OrderAppPayPerLinkOrderLine>;
  paymentRequest: OrderAppPaymentRequestData;
  preOrderDeposit?: Maybe<OrderAppMoney>;
  preOrderDepositPercentage?: Maybe<Scalars['Int']['output']>;
  shippingAddress: OrderAppAddress;
  shippingPrice: OrderAppTaxedMoney;
  subtotal: OrderAppTaxedMoney;
  total: OrderAppTaxedMoney;
  userEmail: Scalars['String']['output'];
};

export type OrderAppPayPerLinkOrderLine = {
  __typename?: 'PayPerLinkOrderLine';
  id: Scalars['String']['output'];
  isShippingRequired: Scalars['Boolean']['output'];
  metadata?: Maybe<Array<OrderAppMetadataItem>>;
  productName?: Maybe<Scalars['String']['output']>;
  productSku?: Maybe<Scalars['String']['output']>;
  productVariantId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  quantityFulfilled: Scalars['Int']['output'];
  quantityToFulfill: Scalars['Int']['output'];
  taxRate?: Maybe<Scalars['Float']['output']>;
  thumbnail?: Maybe<OrderAppThumbnail>;
  totalPrice: OrderAppTaxedMoney;
  undiscountedUnitPrice: OrderAppTaxedMoney;
  unitDiscount: OrderAppMoney;
  unitDiscountReason?: Maybe<Scalars['String']['output']>;
  unitDiscountType?: Maybe<OrderAppDiscountValueTypeEnum>;
  unitDiscountValue: Scalars['Float']['output'];
  unitPrice: OrderAppTaxedMoney;
  variant?: Maybe<OrderAppPaymentProductVariant>;
  variantName?: Maybe<Scalars['String']['output']>;
};

export type OrderAppPaymentCaptureRetryResult = {
  __typename?: 'PaymentCaptureRetryResult';
  errors: Array<OrderAppError>;
};

export type OrderAppPaymentProduct = {
  __typename?: 'PaymentProduct';
  category?: Maybe<OrderAppCategory>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Array<OrderAppMetadataItem>>;
};

export type OrderAppPaymentProductVariant = {
  __typename?: 'PaymentProductVariant';
  id: Scalars['ID']['output'];
  product: OrderAppPaymentProduct;
};

export type OrderAppPaymentRequestData = {
  __typename?: 'PaymentRequestData';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  transactionType: OrderAppTransactionTypeEnum;
};

export type OrderAppPreOrderConfig = {
  __typename?: 'PreOrderConfig';
  availableFrom?: Maybe<Scalars['DateTime']['output']>;
  availableTo?: Maybe<Scalars['DateTime']['output']>;
  dedicatedStock?: Maybe<Scalars['Int']['output']>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  depositPercentage?: Maybe<Scalars['Int']['output']>;
  forcePreOrder?: Maybe<Scalars['Boolean']['output']>;
  isInfiniteStock?: Maybe<Scalars['Boolean']['output']>;
  market: Scalars['String']['output'];
  notifyMe?: Maybe<Scalars['Boolean']['output']>;
  preOrder?: Maybe<OrderAppPreOrderConfigEnum>;
};

export type OrderAppPreOrderConfigEnum =
  | 'OFF'
  | 'ON';

export type OrderAppProduct = {
  __typename?: 'Product';
  attribute?: Maybe<OrderAppSelectedAttribute>;
  category: OrderAppCategory;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: OrderAppProductType;
  thumbnail?: Maybe<OrderAppImage>;
  translation?: Maybe<OrderAppProductTranslation>;
};


export type OrderAppProductAttributeArgs = {
  slug: Scalars['String']['input'];
};


export type OrderAppProductThumbnailArgs = {
  format?: InputMaybe<OrderAppThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type OrderAppProductTranslationArgs = {
  languageCode: OrderAppLanguageCodeEnum;
};

export type OrderAppProductTranslation = {
  __typename?: 'ProductTranslation';
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderAppProductType = {
  __typename?: 'ProductType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OrderAppProductVariant = {
  __typename?: 'ProductVariant';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  preOrderQuantityAvailable?: Maybe<Scalars['Int']['output']>;
  product: OrderAppProduct;
  quantityAvailable: Scalars['Int']['output'];
  sellable?: Maybe<Scalars['Boolean']['output']>;
  sku: Scalars['String']['output'];
  variantCTA: OrderAppCtaType;
};


export type OrderAppProductVariantSellableArgs = {
  sellingType?: InputMaybe<OrderAppSellingTypeEnum>;
};


export type OrderAppProductVariantVariantCtaArgs = {
  fromCPI?: InputMaybe<Scalars['Boolean']['input']>;
  sellingType?: InputMaybe<OrderAppSellingTypeEnum>;
};

export type OrderAppProductVariantBulkUpdateResult = {
  __typename?: 'ProductVariantBulkUpdateResult';
  errors: Array<OrderAppError>;
  results?: Maybe<Array<OrderAppProductVariantUpdateResult>>;
};

export type OrderAppProductVariantInput = {
  preOrderConfig: Array<InputMaybe<OrderAppMarketPreOrderConfigInput>>;
  sku: Scalars['String']['input'];
};

export type OrderAppProductVariantUpdateResult = {
  __typename?: 'ProductVariantUpdateResult';
  errors: Array<OrderAppError>;
  preOrderConfig?: Maybe<Array<Maybe<OrderAppPreOrderConfig>>>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type OrderAppProductVariantsWithPreOrderConfig = {
  __typename?: 'ProductVariantsWithPreOrderConfig';
  defaultVisible?: Maybe<Scalars['Boolean']['output']>;
  marketSellable?: Maybe<Array<Maybe<OrderAppMarketSellable>>>;
  marketVisible?: Maybe<Array<Maybe<OrderAppMarketVisible>>>;
  phoneDefaultSellable?: Maybe<Scalars['Boolean']['output']>;
  preOrderConfig?: Maybe<Array<Maybe<OrderAppPreOrderConfig>>>;
  sku: Scalars['String']['output'];
  webDefaultSellable?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderAppQuery = {
  __typename?: 'Query';
  billingCountries: Array<OrderAppBillingCountry>;
  channelConfig?: Maybe<OrderAppChannelConfig>;
  checkout?: Maybe<OrderAppCheckout>;
  countriesChannels: Array<OrderAppCountryChannel>;
  dynamicSetting: OrderAppSettingResult;
  gwpProducts?: Maybe<Array<OrderAppGwpProduct>>;
  order?: Maybe<OrderAppOrder>;
  orderByPaymentToken?: Maybe<OrderAppPayPerLinkOrder>;
  orderIdByBusinessIdAndEmail?: Maybe<OrderAppIdOnlyOrder>;
  productVariant?: Maybe<OrderAppProductVariant>;
  productVariants?: Maybe<Array<OrderAppProductVariant>>;
  productVariantsWithPreOrderConfig?: Maybe<Array<OrderAppProductVariantsWithPreOrderConfig>>;
  /**
   * Calculates the gross and tax refund amounts for the given net refund amounts
   * per line.
   */
  refundCalculateTax: OrderAppRefundCalculateTaxResult;
  /** Return reasons available to storefront and backoffice clients. */
  returnReasons: Array<OrderAppReturnReason>;
  storefrontOfflinePaymentAvailability: Scalars['Boolean']['output'];
  validateCheckout: OrderAppCheckoutValidationResult;
  validateOrder: OrderAppOrderValidationResult;
  voucher?: Maybe<OrderAppVoucherObject>;
  withdrawalEligibility: OrderAppWithdrawalEligibilityResult;
};


export type OrderAppQueryChannelConfigArgs = {
  channel: Scalars['String']['input'];
};


export type OrderAppQueryCheckoutArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppQueryDynamicSettingArgs = {
  name: OrderAppDynamicSettingsEnum;
};


export type OrderAppQueryGwpProductsArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  checkout_id?: InputMaybe<Scalars['String']['input']>;
  thresh_hold?: InputMaybe<Scalars['String']['input']>;
};


export type OrderAppQueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppQueryOrderByPaymentTokenArgs = {
  token: Scalars['String']['input'];
};


export type OrderAppQueryOrderIdByBusinessIdAndEmailArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  businessId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};


export type OrderAppQueryProductVariantArgs = {
  channel: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};


export type OrderAppQueryProductVariantsArgs = {
  channel: Scalars['String']['input'];
  skus: Array<Scalars['String']['input']>;
};


export type OrderAppQueryProductVariantsWithPreOrderConfigArgs = {
  skus: Array<Scalars['String']['input']>;
};


export type OrderAppQueryRefundCalculateTaxArgs = {
  orderId: Scalars['ID']['input'];
  refundLines: Array<OrderAppRefundCalculateTaxLineInput>;
};


export type OrderAppQueryReturnReasonsArgs = {
  audience?: InputMaybe<OrderAppReturnReasonAudience>;
};


export type OrderAppQueryStorefrontOfflinePaymentAvailabilityArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppQueryValidateCheckoutArgs = {
  checkAddress?: InputMaybe<Scalars['Boolean']['input']>;
  checkPrices?: InputMaybe<Scalars['Boolean']['input']>;
  checkStocks?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type OrderAppQueryValidateOrderArgs = {
  id: Scalars['ID']['input'];
};


export type OrderAppQueryVoucherArgs = {
  channel: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type OrderAppQueryWithdrawalEligibilityArgs = {
  input: OrderAppWithdrawalEligibilityInput;
};

export type OrderAppReferenceDateSource =
  | 'DELIVERED'
  | 'ORDER_EVENT';

export type OrderAppRefundAmount = {
  gross: Scalars['Float']['input'];
  net: Scalars['Float']['input'];
  tax: Scalars['Float']['input'];
};

export type OrderAppRefundCalculateTaxLineInput = {
  orderLineId: Scalars['ID']['input'];
  refundAmount: Scalars['Float']['input'];
};

export type OrderAppRefundCalculateTaxLineResult = {
  __typename?: 'RefundCalculateTaxLineResult';
  gross: Scalars['Float']['output'];
  net: Scalars['Float']['output'];
  orderLineId: Scalars['ID']['output'];
  tax: Scalars['Float']['output'];
};

export type OrderAppRefundCalculateTaxResult = {
  __typename?: 'RefundCalculateTaxResult';
  refundLines: Array<OrderAppRefundCalculateTaxLineResult>;
};

export type OrderAppRefundCreateResult = {
  __typename?: 'RefundCreateResult';
  errors: Array<OrderAppError>;
};

export type OrderAppRefundLine = {
  amount: OrderAppRefundAmount;
  comment?: InputMaybe<Scalars['String']['input']>;
  order_line_id: Scalars['ID']['input'];
};

export type OrderAppRerouteFulfillmentLocationResult = {
  __typename?: 'RerouteFulfillmentLocationResult';
  errors: Array<OrderAppError>;
  success: Scalars['Boolean']['output'];
};

export type OrderAppResendReturnLabelResponse = {
  __typename?: 'ResendReturnLabelResponse';
  errors: Array<OrderAppError>;
  success: Scalars['Boolean']['output'];
};

/** User-selectable return reason with stable identifier and localized labels. */
export type OrderAppReturnReason = {
  __typename?: 'ReturnReason';
  /** Client audiences for which this reason should be displayed. */
  audiences: Array<OrderAppReturnReasonAudience>;
  /** Stable identifier matching the values accepted by orderReturnCreate. */
  id: Scalars['ID']['output'];
  /** Localized labels ordered by supported language. */
  translations: Array<OrderAppReturnReasonTranslation>;
};

export type OrderAppReturnReasonAudience =
  | 'BACKOFFICE'
  | 'STOREFRONT';

/** Localized label for a return reason. */
export type OrderAppReturnReasonTranslation = {
  __typename?: 'ReturnReasonTranslation';
  /** Supported language code for this translation. */
  languageCode: Scalars['String']['output'];
  /** User-facing label shown for the return reason. */
  value: Scalars['String']['output'];
};

export type OrderAppSelectedAttribute = {
  __typename?: 'SelectedAttribute';
  attribute: OrderAppAttribute;
  values: Array<OrderAppAttributeValue>;
};

export type OrderAppSellingTypeEnum =
  | 'PHONE'
  | 'WEB';

export type OrderAppSendInvoiceResponse = {
  __typename?: 'SendInvoiceResponse';
  errors: Array<OrderAppError>;
  success: Scalars['Boolean']['output'];
};

export type OrderAppSetting = {
  __typename?: 'Setting';
  modified?: Maybe<Scalars['Float']['output']>;
  modifiedBy: Scalars['String']['output'];
  name: OrderAppDynamicSettingsEnum;
  value?: Maybe<Scalars['String']['output']>;
};

export type OrderAppSettingResult = {
  __typename?: 'SettingResult';
  errors: Array<OrderAppError>;
  setting?: Maybe<OrderAppSetting>;
};

export type OrderAppShippingUpdateResult = {
  __typename?: 'ShippingUpdateResult';
  errors: Array<OrderAppError>;
  order?: Maybe<OrderAppOrder>;
};

export type OrderAppStrapItemInput = {
  additionalBuckle?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
};

export type OrderAppStrapPackInput = {
  strapItem1: OrderAppStrapItemInput;
  strapItem2: OrderAppStrapItemInput;
};

export type OrderAppStrapRelatedProductsInput = {
  buckleId: Scalars['String']['input'];
};

export type OrderAppSubscriptionUpdateResult = {
  __typename?: 'SubscriptionUpdateResult';
  errors: Array<OrderAppError>;
  order?: Maybe<OrderAppOrder>;
};

export type OrderAppTaxedMoney = {
  __typename?: 'TaxedMoney';
  currency: Scalars['String']['output'];
  gross: OrderAppMoney;
  net: OrderAppMoney;
  tax: OrderAppMoney;
};

export type OrderAppThumbnail = {
  __typename?: 'Thumbnail';
  url: Scalars['String']['output'];
};

export type OrderAppThumbnailFormatEnum =
  | 'AVIF'
  | 'ORIGINAL'
  | 'WEBP';

export type OrderAppTransactionTypeEnum =
  | 'BALANCE'
  | 'DEPOSIT'
  | 'FULL';

export type OrderAppUpdateEngravingInfoResult = {
  __typename?: 'UpdateEngravingInfoResult';
  errors: Array<OrderAppError>;
};

export type OrderAppUpdateMetadataResult = {
  __typename?: 'UpdateMetadataResult';
  errors: Array<OrderAppError>;
  item?: Maybe<OrderAppObjectWithMetadata>;
};

export type OrderAppUser = {
  __typename?: 'User';
  addresses?: Maybe<Array<Maybe<OrderAppAddress>>>;
  dateJoined?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type OrderAppVoucherObject = {
  __typename?: 'VoucherObject';
  discountValueType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OrderAppWithdrawalAccessMode =
  | 'AUTHENTICATED'
  | 'GUEST'
  | 'STAFF';

export type OrderAppWithdrawalCustomer = {
  __typename?: 'WithdrawalCustomer';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type OrderAppWithdrawalEligibilityCode =
  | 'OK';

export type OrderAppWithdrawalEligibilityInput = {
  brand: Scalars['String']['input'];
  guestLookup?: InputMaybe<OrderAppGuestLookupInput>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderAppWithdrawalEligibilityResult = {
  __typename?: 'WithdrawalEligibilityResult';
  errors: Array<OrderAppError>;
  withdrawal?: Maybe<OrderAppWithdrawalInfo>;
};

export type OrderAppWithdrawalInfo = {
  __typename?: 'WithdrawalInfo';
  accessMode: OrderAppWithdrawalAccessMode;
  code: OrderAppWithdrawalEligibilityCode;
  customer: OrderAppWithdrawalCustomer;
  lines: Array<OrderAppWithdrawalLine>;
  order: OrderAppWithdrawalOrderSummary;
};

export type OrderAppWithdrawalLine = {
  __typename?: 'WithdrawalLine';
  disabledReasonCode?: Maybe<OrderAppDisabledReasonCode>;
  eligibleQuantity: Scalars['Int']['output'];
  orderLineId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  referenceDate?: Maybe<Scalars['DateTime']['output']>;
  referenceDateSource?: Maybe<OrderAppReferenceDateSource>;
  sku: Scalars['String']['output'];
  status: OrderAppWithdrawalLineStatus;
  windowEndAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderAppWithdrawalLineStatus =
  | 'ELIGIBLE'
  | 'INELIGIBLE';

export type OrderAppWithdrawalOrderSummary = {
  __typename?: 'WithdrawalOrderSummary';
  businessId: Scalars['String']['output'];
  channel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type OrderAppWithdrawalSubmitCode =
  | 'OK';

export type OrderAppWithdrawalSubmitInfo = {
  __typename?: 'WithdrawalSubmitInfo';
  code: OrderAppWithdrawalSubmitCode;
  items: Array<OrderAppWithdrawalSubmitLine>;
  submittedAt: Scalars['DateTime']['output'];
  withdrawalRequestId: Scalars['ID']['output'];
};

export type OrderAppWithdrawalSubmitInput = {
  brand: Scalars['String']['input'];
  guestContext?: InputMaybe<OrderAppGuestContextInput>;
  items: Array<OrderAppWithdrawalSubmitLineInput>;
  orderId: Scalars['ID']['input'];
};

export type OrderAppWithdrawalSubmitLine = {
  __typename?: 'WithdrawalSubmitLine';
  comment?: Maybe<Scalars['String']['output']>;
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  reasonCode?: Maybe<OrderAppOrderReturnReason>;
  status: Scalars['String']['output'];
  translatedReason?: Maybe<Scalars['String']['output']>;
};

export type OrderAppWithdrawalSubmitLineInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  orderLineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  reasonCode?: InputMaybe<OrderAppOrderReturnReason>;
  translatedReason?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAppWithdrawalSubmitResult = {
  __typename?: 'WithdrawalSubmitResult';
  errors: Array<OrderAppError>;
  withdrawalSubmit?: Maybe<OrderAppWithdrawalSubmitInfo>;
};

export type OrderAppBillingCountryFragment = { __typename?: 'BillingCountry', code?: string | null, name?: string | null };

export type OrderAppDeliveryScheduleMetadataFragment = { __typename?: 'ObjectWithMetadata', timeSlot?: string | null };

export type OrderAppCheckoutLineBraceletSizeMetadataFragment = { __typename?: 'ObjectWithMetadata', relatedBraceletSize?: string | null };

export type OrderAppErrorFragment = { __typename?: 'Error', field: string, code: string, context?: string | null, message: string };

export type OrderAppGiftMetadataFragment = { __typename?: 'ObjectWithMetadata', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

export type OrderAppMetadataItemFragment = { __typename?: 'MetadataItem', key: string, value: string };

export type OrderAppOrderExtraDataFragment = { __typename?: 'Order', id: string, businessId: string };

export type OrderAppOrderFlowMetadataFragment = { __typename?: 'ObjectWithMetadata', orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

export type OrderAppPayPerLinkOrderExtraDataFragment = { __typename?: 'PayPerLinkOrder', id: string, businessId: string, expirationTimestamp: number };

export type OrderAppPreorderMetadataFragment = { __typename?: 'ObjectWithMetadata', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

export type OrderAppProductVariantBusinessDetailsFragment = { __typename?: 'ProductVariant', variantCTA: OrderAppCtaType, quantityAvailable: number, sku: string, phoneCTA: OrderAppCtaType, webSellable?: boolean | null };

export type OrderAppCheckoutVoucherAddMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  code: Scalars['String']['input'];
}>;


export type OrderAppCheckoutVoucherAddMutation = { __typename?: 'Mutation', checkoutVoucherAdd: { __typename?: 'CheckoutVoucherAddResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } };

export type OrderAppCheckoutAddressTitleMetadataUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  shippingTitle: Scalars['String']['input'];
  billingTitle: Scalars['String']['input'];
}>;


export type OrderAppCheckoutAddressTitleMetadataUpdateMutation = { __typename?: 'Mutation', updateMetadata: { __typename?: 'UpdateMetadataResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }>, item?: { __typename?: 'ObjectWithMetadata', shippingTitle?: string | null, billingTitle?: string | null } | null } };

export type OrderAppCheckoutCreateMutationVariables = Exact<{
  channelSlug: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderAppCheckoutCreateMutation = { __typename?: 'Mutation', checkoutCreate?: { __typename?: 'CheckoutCreate', checkout?: { __typename?: 'CheckoutCreateCheckout', id: string, email?: string | null, user?: { __typename?: 'CheckoutCreateUser', email?: string | null } | null } | null, errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } | null };

export type OrderAppCheckoutDeliveryModeUpdateMutationVariables = Exact<{
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  deliveryMode: OrderAppDeliveryMode;
  boutiqueExtReference?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<OrderAppAddressInput>;
}>;


export type OrderAppCheckoutDeliveryModeUpdateMutation = { __typename?: 'Mutation', deliveryModeUpdate: { __typename?: 'DeliveryModeUpdateResult', errors: Array<{ __typename?: 'Error', field: string, code: string, message: string }> } };

export type OrderAppCheckoutDeliveryScheduleMetadataDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderAppCheckoutDeliveryScheduleMetadataDeleteMutation = { __typename?: 'Mutation', deleteMetadata: { __typename?: 'DeleteMetadata', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }>, item?: { __typename?: 'ObjectWithMetadata', timeSlot?: string | null } | null } };

export type OrderAppCheckoutDeliveryScheduleMetadataUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  timeSlot: Scalars['String']['input'];
}>;


export type OrderAppCheckoutDeliveryScheduleMetadataUpdateMutation = { __typename?: 'Mutation', updateMetadata: { __typename?: 'UpdateMetadataResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }>, item?: { __typename?: 'ObjectWithMetadata', timeSlot?: string | null } | null } };

export type OrderAppCheckoutGwpUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  checkoutGwp: OrderAppCheckoutGwpInput;
}>;


export type OrderAppCheckoutGwpUpdateMutation = { __typename?: 'Mutation', gwpCheckoutUpdate: { __typename?: 'CheckoutGwpUpdateResult', errors: Array<{ __typename?: 'Error', field: string, code: string, message: string }> } };

export type OrderAppCheckoutLineBraceletSizeMetadataUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  braceletSize: Scalars['String']['input'];
}>;


export type OrderAppCheckoutLineBraceletSizeMetadataUpdateMutation = { __typename?: 'Mutation', updateMetadata: { __typename?: 'UpdateMetadataResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }>, item?: { __typename?: 'ObjectWithMetadata', relatedBraceletSize?: string | null } | null } };

export type OrderAppCheckoutLinesAddMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  lines: Array<OrderAppCheckoutLineInput> | OrderAppCheckoutLineInput;
}>;


export type OrderAppCheckoutLinesAddMutation = { __typename?: 'Mutation', checkoutLinesAdd: { __typename?: 'CheckoutLinesAddResult', requiresSocialClubTerms?: boolean | null, errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } };

export type OrderAppCheckoutLinesDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  linesIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrderAppCheckoutLinesDeleteMutation = { __typename?: 'Mutation', checkoutLinesDelete: { __typename?: 'CheckoutLinesDeleteResult', requiresSocialClubTerms?: boolean | null, errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } };

export type OrderAppCheckoutVoucherDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderAppCheckoutVoucherDeleteMutation = { __typename?: 'Mutation', checkoutVoucherDelete: { __typename?: 'CheckoutVoucherDeleteResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } };

export type OrderAppCheckoutShippingAddressUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  address: OrderAppAddressInput;
  validationRules?: InputMaybe<OrderAppCheckoutAddressValidationRules>;
}>;


export type OrderAppCheckoutShippingAddressUpdateMutation = { __typename?: 'Mutation', checkoutShippingAddressUpdate: { __typename?: 'CheckoutShippingAddressUpdateResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } };

export type OrderAppDeleteMetadataMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  keys: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrderAppDeleteMetadataMutation = { __typename?: 'Mutation', deleteMetadata: { __typename?: 'DeleteMetadata', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }>, item?: { __typename?: 'ObjectWithMetadata', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } };

export type OrderAppGiftMetadataDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderAppGiftMetadataDeleteMutation = { __typename?: 'Mutation', deleteMetadata: { __typename?: 'DeleteMetadata', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }>, item?: { __typename?: 'ObjectWithMetadata', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null } | null } };

export type OrderAppGiftMetadataUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  giftFrom: Scalars['String']['input'];
  giftMessage: Scalars['String']['input'];
}>;


export type OrderAppGiftMetadataUpdateMutation = { __typename?: 'Mutation', updateMetadata: { __typename?: 'UpdateMetadataResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }>, item?: { __typename?: 'ObjectWithMetadata', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null } | null } };

export type OrderAppOfflinePaymentToggleMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type OrderAppOfflinePaymentToggleMutation = { __typename?: 'Mutation', offlinePaymentToggle: { __typename?: 'OfflinePaymentToggleResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } };

export type OrderAppOrderAbandonMutationVariables = Exact<{
  checkoutId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
}>;


export type OrderAppOrderAbandonMutation = { __typename?: 'Mutation', orderAbandon: { __typename?: 'OrderAbandonResult', newBusinessId?: string | null, errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } };

export type OrderAppOrderCreateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderAppOrderCreateMutation = { __typename?: 'Mutation', orderCreate: { __typename?: 'OrderCreateResult', order?: { __typename?: 'Order', id: string } | null, errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } };

export type OrderAppOrderGwpUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  orderGwp: OrderAppOrderGwpInput;
}>;


export type OrderAppOrderGwpUpdateMutation = { __typename?: 'Mutation', gwpOrderUpdate: { __typename?: 'OrderGwpUpdateResult', errors: Array<{ __typename?: 'Error', field: string, code: string, message: string }> } };

export type OrderAppOrderPayPerLinkTokenCreateMutationVariables = Exact<{
  invitationMethod: OrderAppInvitationMethod;
  id: Scalars['ID']['input'];
}>;


export type OrderAppOrderPayPerLinkTokenCreateMutation = { __typename?: 'Mutation', orderSendPaymentInvitation: { __typename?: 'OrderSendPaymentInvitationResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } };

export type OrderAppOrderShippingAddressUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  address: OrderAppAddressInput;
}>;


export type OrderAppOrderShippingAddressUpdateMutation = { __typename?: 'Mutation', orderShippingAddressUpdate: { __typename?: 'OrderShippingAddressUpdateResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } };

export type OrderAppOrderUpdateClientDetailsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderAppOrderUpdateClientDetailsMutation = { __typename?: 'Mutation', orderUpdateClientDetails: { __typename?: 'OrderUpdateClientDetailsResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } };

export type OrderAppPaymentMethodMetadataUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
}>;


export type OrderAppPaymentMethodMetadataUpdateMutation = { __typename?: 'Mutation', updateMetadata: { __typename?: 'UpdateMetadataResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } };

export type OrderAppProductVariantBusinessDetailsQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  channel: Scalars['String']['input'];
}>;


export type OrderAppProductVariantBusinessDetailsQuery = { __typename?: 'Query', productVariant?: { __typename?: 'ProductVariant', variantCTA: OrderAppCtaType, quantityAvailable: number, sku: string, phoneCTA: OrderAppCtaType, webSellable?: boolean | null } | null };

export type OrderAppProductVariantsBusinessDetailsQueryVariables = Exact<{
  skus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  channel: Scalars['String']['input'];
}>;


export type OrderAppProductVariantsBusinessDetailsQuery = { __typename?: 'Query', productVariants?: Array<{ __typename?: 'ProductVariant', variantCTA: OrderAppCtaType, quantityAvailable: number, sku: string, phoneCTA: OrderAppCtaType, webSellable?: boolean | null }> | null };

export type OrderAppUpdateMetadataMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: Array<OrderAppMetadataInput> | OrderAppMetadataInput;
}>;


export type OrderAppUpdateMetadataMutation = { __typename?: 'Mutation', updateMetadata: { __typename?: 'UpdateMetadataResult', errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }>, item?: { __typename?: 'ObjectWithMetadata', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } };

export type OrderAppStorefrontWithdrawalSubmitMutationVariables = Exact<{
  input: OrderAppWithdrawalSubmitInput;
}>;


export type OrderAppStorefrontWithdrawalSubmitMutation = { __typename?: 'Mutation', withdrawalSubmit: { __typename?: 'WithdrawalSubmitResult', withdrawalSubmit?: { __typename?: 'WithdrawalSubmitInfo', code: OrderAppWithdrawalSubmitCode, withdrawalRequestId: string, submittedAt: string, items: Array<{ __typename?: 'WithdrawalSubmitLine', orderLineId: string, quantity: number, reasonCode?: OrderAppOrderReturnReason | null, translatedReason?: string | null, comment?: string | null, status: string }> } | null, errors: Array<{ __typename?: 'Error', code: string, message: string, field: string, context?: string | null }> } };

export type OrderAppBillingCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderAppBillingCountriesQuery = { __typename?: 'Query', billingCountries: Array<{ __typename?: 'BillingCountry', code?: string | null, name?: string | null }> };

export type OrderAppCheckoutChannelConfigQueryVariables = Exact<{
  channel: Scalars['String']['input'];
}>;


export type OrderAppCheckoutChannelConfigQuery = { __typename?: 'Query', channelConfig?: { __typename?: 'ChannelConfig', deliveryModes: Array<OrderAppDeliveryMode> } | null };

export type OrderAppGwpProductsQueryVariables = Exact<{
  checkout_id: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  thresh_hold?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderAppGwpProductsQuery = { __typename?: 'Query', gwpProducts?: Array<{ __typename?: 'GwpProduct', slug: string, id: string, name: string, available_quantity: number, product_type_slug: string, threshhold: string, thumbnail_alt?: string | null, thumbnail_url?: string | null }> | null };

export type OrderAppOfflinePaymentAvailabilityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderAppOfflinePaymentAvailabilityQuery = { __typename?: 'Query', storefrontOfflinePaymentAvailability: boolean };

export type OrderAppOrderExtraDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderAppOrderExtraDataQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, businessId: string } | null };

export type OrderAppOrderIdByBusinessIdAndEmailQueryVariables = Exact<{
  businessId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
}>;


export type OrderAppOrderIdByBusinessIdAndEmailQuery = { __typename?: 'Query', orderIdByBusinessIdAndEmail?: { __typename?: 'IdOnlyOrder', id: string } | null };

export type OrderAppPayPerLinkOrderExtraDataQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type OrderAppPayPerLinkOrderExtraDataQuery = { __typename?: 'Query', orderByPaymentToken?: { __typename?: 'PayPerLinkOrder', id: string, businessId: string, expirationTimestamp: number } | null };

export type OrderAppStorefrontReturnReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderAppStorefrontReturnReasonsQuery = { __typename?: 'Query', returnReasons: Array<{ __typename?: 'ReturnReason', id: string, audiences: Array<OrderAppReturnReasonAudience>, translations: Array<{ __typename?: 'ReturnReasonTranslation', languageCode: string, value: string }> }> };

export type OrderAppValidateCheckoutQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  checkPrices?: InputMaybe<Scalars['Boolean']['input']>;
  checkStocks?: InputMaybe<Scalars['Boolean']['input']>;
  checkAddress?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrderAppValidateCheckoutQuery = { __typename?: 'Query', validateCheckout: { __typename?: 'CheckoutValidationResult', checkoutId: string, valid: boolean, errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } };

export type OrderAppGetVoucherQueryVariables = Exact<{
  code: Scalars['String']['input'];
  channel: Scalars['String']['input'];
}>;


export type OrderAppGetVoucherQuery = { __typename?: 'Query', voucher?: { __typename?: 'VoucherObject', type: string, discountValueType: string } | null };

export type OrderAppStorefrontWithdrawalEligibilityQueryVariables = Exact<{
  input: OrderAppWithdrawalEligibilityInput;
}>;


export type OrderAppStorefrontWithdrawalEligibilityQuery = { __typename?: 'Query', withdrawalEligibility: { __typename?: 'WithdrawalEligibilityResult', withdrawal?: { __typename?: 'WithdrawalInfo', code: OrderAppWithdrawalEligibilityCode, accessMode: OrderAppWithdrawalAccessMode, customer: { __typename?: 'WithdrawalCustomer', email: string, firstName?: string | null, lastName?: string | null }, order: { __typename?: 'WithdrawalOrderSummary', id: string, businessId: string, status: string, createdAt?: string | null, channel?: string | null }, lines: Array<{ __typename?: 'WithdrawalLine', orderLineId: string, productName: string, sku: string, quantity: number, eligibleQuantity: number, status: OrderAppWithdrawalLineStatus, disabledReasonCode?: OrderAppDisabledReasonCode | null, referenceDate?: string | null, referenceDateSource?: OrderAppReferenceDateSource | null, windowEndAt?: string | null }> } | null, errors: Array<{ __typename?: 'Error', code: string, message: string }> } };

export type OrderAppOrderValidationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderAppOrderValidationQuery = { __typename?: 'Query', validateOrder: { __typename?: 'OrderValidationResult', id: string, valid: boolean, errors: Array<{ __typename?: 'Error', field: string, code: string, context?: string | null, message: string }> } };

export const BillingCountryFragmentDoc = gql`
    fragment BillingCountry on BillingCountry {
  code
  name
}
    `;
export const DeliveryScheduleMetadataFragmentDoc = gql`
    fragment DeliveryScheduleMetadata on ObjectWithMetadata {
  timeSlot: metafield(key: "time_slot")
}
    `;
export const CheckoutLineBraceletSizeMetadataFragmentDoc = gql`
    fragment CheckoutLineBraceletSizeMetadata on ObjectWithMetadata {
  relatedBraceletSize: metafield(key: "relatedBraceletSize")
}
    `;
export const ErrorFragmentDoc = gql`
    fragment Error on Error {
  field
  code
  context
  message
}
    `;
export const GiftMetadataFragmentDoc = gql`
    fragment GiftMetadata on ObjectWithMetadata {
  isGift: metafield(key: "gift")
  giftFrom: metafield(key: "gift_from")
  giftMessage: metafield(key: "gift_message")
}
    `;
export const MetadataItemFragmentDoc = gql`
    fragment MetadataItem on MetadataItem {
  key
  value
}
    `;
export const OrderExtraDataFragmentDoc = gql`
    fragment OrderExtraData on Order {
  id
  businessId
}
    `;
export const OrderFlowMetadataFragmentDoc = gql`
    fragment OrderFlowMetadata on ObjectWithMetadata {
  orderFlowScTermsAccepted: metafield(key: "orderFlow.scTermsAccepted")
  orderFlowWasUserAuthenticated: metafield(key: "orderFlow.wasUserAuthenticated")
  orderFlowWasRegisterMyWatchChecked: metafield(
    key: "orderFlow.wasRegisterMyWatchChecked"
  )
  orderFlowWasCreateMyAccountWithoutWatchChecked: metafield(
    key: "orderFlow.wasCreateMyAccountWithoutWatchChecked"
  )
  orderFlowWasAccountCreated: metafield(key: "orderFlow.wasAccountCreated")
  orderFlowUserJoinClub: metafield(key: "orderFlow.userJoinClub")
  orderFlowUserAffiliated: metafield(key: "orderFlow.userAffiliated")
  orderFlowReceiveReceipt: metafield(key: "orderFlow.japanReceipt")
  checkoutId: metafield(key: "checkout.id")
}
    `;
export const PayPerLinkOrderExtraDataFragmentDoc = gql`
    fragment PayPerLinkOrderExtraData on PayPerLinkOrder {
  id
  businessId
  expirationTimestamp
}
    `;
export const PreorderMetadataFragmentDoc = gql`
    fragment PreorderMetadata on ObjectWithMetadata {
  preOrderData: metafield(key: "preorder_data")
  orderType: metafield(key: "order.type")
  orderStatus: metafield(key: "order.status")
  orderCollectedDate: metafield(key: "order.collected_date")
  payPerLinkToken: metafield(key: "order.pay_per_link_token")
  payPerLinkExpiration: metafield(key: "order.pay_per_link_token_expiration_time")
}
    `;
export const ProductVariantBusinessDetailsFragmentDoc = gql`
    fragment ProductVariantBusinessDetails on ProductVariant {
  variantCTA
  phoneCTA: variantCTA(fromCPI: false, sellingType: PHONE)
  quantityAvailable
  webSellable: sellable(sellingType: WEB)
  sku
}
    `;
export const CheckoutVoucherAddDocument = gql`
    mutation CheckoutVoucherAdd($id: ID!, $code: String!) {
  checkoutVoucherAdd(id: $id, code: $code) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type OrderAppCheckoutVoucherAddMutationFn = Apollo.MutationFunction<OrderAppCheckoutVoucherAddMutation, OrderAppCheckoutVoucherAddMutationVariables>;

/**
 * __useCheckoutVoucherAddMutation__
 *
 * To run a mutation, you first call `useCheckoutVoucherAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutVoucherAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutVoucherAddMutation, { data, loading, error }] = useCheckoutVoucherAddMutation({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCheckoutVoucherAddMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppCheckoutVoucherAddMutation, OrderAppCheckoutVoucherAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppCheckoutVoucherAddMutation, OrderAppCheckoutVoucherAddMutationVariables>(CheckoutVoucherAddDocument, options);
      }
export type CheckoutVoucherAddMutationHookResult = ReturnType<typeof useCheckoutVoucherAddMutation>;
export type CheckoutVoucherAddMutationResult = Apollo.MutationResult<OrderAppCheckoutVoucherAddMutation>;
export type CheckoutVoucherAddMutationOptions = Apollo.BaseMutationOptions<OrderAppCheckoutVoucherAddMutation, OrderAppCheckoutVoucherAddMutationVariables>;
export const CheckoutAddressTitleMetadataUpdateDocument = gql`
    mutation CheckoutAddressTitleMetadataUpdate($id: ID!, $shippingTitle: String!, $billingTitle: String!) {
  updateMetadata(
    id: $id
    input: [{key: "shipping.title", value: $shippingTitle}, {key: "billing.title", value: $billingTitle}]
  ) {
    errors {
      ...Error
    }
    item {
      shippingTitle: metafield(key: "shipping.title")
      billingTitle: metafield(key: "billing.title")
    }
  }
}
    ${ErrorFragmentDoc}`;
export type OrderAppCheckoutAddressTitleMetadataUpdateMutationFn = Apollo.MutationFunction<OrderAppCheckoutAddressTitleMetadataUpdateMutation, OrderAppCheckoutAddressTitleMetadataUpdateMutationVariables>;

/**
 * __useCheckoutAddressTitleMetadataUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutAddressTitleMetadataUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutAddressTitleMetadataUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutAddressTitleMetadataUpdateMutation, { data, loading, error }] = useCheckoutAddressTitleMetadataUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      shippingTitle: // value for 'shippingTitle'
 *      billingTitle: // value for 'billingTitle'
 *   },
 * });
 */
export function useCheckoutAddressTitleMetadataUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppCheckoutAddressTitleMetadataUpdateMutation, OrderAppCheckoutAddressTitleMetadataUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppCheckoutAddressTitleMetadataUpdateMutation, OrderAppCheckoutAddressTitleMetadataUpdateMutationVariables>(CheckoutAddressTitleMetadataUpdateDocument, options);
      }
export type CheckoutAddressTitleMetadataUpdateMutationHookResult = ReturnType<typeof useCheckoutAddressTitleMetadataUpdateMutation>;
export type CheckoutAddressTitleMetadataUpdateMutationResult = Apollo.MutationResult<OrderAppCheckoutAddressTitleMetadataUpdateMutation>;
export type CheckoutAddressTitleMetadataUpdateMutationOptions = Apollo.BaseMutationOptions<OrderAppCheckoutAddressTitleMetadataUpdateMutation, OrderAppCheckoutAddressTitleMetadataUpdateMutationVariables>;
export const CheckoutCreateDocument = gql`
    mutation CheckoutCreate($channelSlug: String!, $email: String, $languageCode: String, $brand: String) {
  checkoutCreate(
    input: {languageCode: $languageCode, email: $email, channel: $channelSlug, brand: $brand}
  ) {
    checkout {
      id
      user {
        email
      }
      email
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type OrderAppCheckoutCreateMutationFn = Apollo.MutationFunction<OrderAppCheckoutCreateMutation, OrderAppCheckoutCreateMutationVariables>;

/**
 * __useCheckoutCreateMutation__
 *
 * To run a mutation, you first call `useCheckoutCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutCreateMutation, { data, loading, error }] = useCheckoutCreateMutation({
 *   variables: {
 *      channelSlug: // value for 'channelSlug'
 *      email: // value for 'email'
 *      languageCode: // value for 'languageCode'
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useCheckoutCreateMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppCheckoutCreateMutation, OrderAppCheckoutCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppCheckoutCreateMutation, OrderAppCheckoutCreateMutationVariables>(CheckoutCreateDocument, options);
      }
export type CheckoutCreateMutationHookResult = ReturnType<typeof useCheckoutCreateMutation>;
export type CheckoutCreateMutationResult = Apollo.MutationResult<OrderAppCheckoutCreateMutation>;
export type CheckoutCreateMutationOptions = Apollo.BaseMutationOptions<OrderAppCheckoutCreateMutation, OrderAppCheckoutCreateMutationVariables>;
export const CheckoutDeliveryModeUpdateDocument = gql`
    mutation CheckoutDeliveryModeUpdate($checkoutId: ID, $orderId: ID, $deliveryMode: DeliveryMode!, $boutiqueExtReference: String, $address: AddressInput) {
  deliveryModeUpdate(
    checkoutId: $checkoutId
    orderId: $orderId
    deliveryMode: $deliveryMode
    boutiqueExtReference: $boutiqueExtReference
    address: $address
  ) {
    errors {
      field
      code
      message
    }
  }
}
    `;
export type OrderAppCheckoutDeliveryModeUpdateMutationFn = Apollo.MutationFunction<OrderAppCheckoutDeliveryModeUpdateMutation, OrderAppCheckoutDeliveryModeUpdateMutationVariables>;

/**
 * __useCheckoutDeliveryModeUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutDeliveryModeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutDeliveryModeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutDeliveryModeUpdateMutation, { data, loading, error }] = useCheckoutDeliveryModeUpdateMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      orderId: // value for 'orderId'
 *      deliveryMode: // value for 'deliveryMode'
 *      boutiqueExtReference: // value for 'boutiqueExtReference'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useCheckoutDeliveryModeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppCheckoutDeliveryModeUpdateMutation, OrderAppCheckoutDeliveryModeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppCheckoutDeliveryModeUpdateMutation, OrderAppCheckoutDeliveryModeUpdateMutationVariables>(CheckoutDeliveryModeUpdateDocument, options);
      }
export type CheckoutDeliveryModeUpdateMutationHookResult = ReturnType<typeof useCheckoutDeliveryModeUpdateMutation>;
export type CheckoutDeliveryModeUpdateMutationResult = Apollo.MutationResult<OrderAppCheckoutDeliveryModeUpdateMutation>;
export type CheckoutDeliveryModeUpdateMutationOptions = Apollo.BaseMutationOptions<OrderAppCheckoutDeliveryModeUpdateMutation, OrderAppCheckoutDeliveryModeUpdateMutationVariables>;
export const CheckoutDeliveryScheduleMetadataDeleteDocument = gql`
    mutation CheckoutDeliveryScheduleMetadataDelete($id: ID!) {
  deleteMetadata(id: $id, keys: ["time_slot"]) {
    errors {
      ...Error
    }
    item {
      ...DeliveryScheduleMetadata
    }
  }
}
    ${ErrorFragmentDoc}
${DeliveryScheduleMetadataFragmentDoc}`;
export type OrderAppCheckoutDeliveryScheduleMetadataDeleteMutationFn = Apollo.MutationFunction<OrderAppCheckoutDeliveryScheduleMetadataDeleteMutation, OrderAppCheckoutDeliveryScheduleMetadataDeleteMutationVariables>;

/**
 * __useCheckoutDeliveryScheduleMetadataDeleteMutation__
 *
 * To run a mutation, you first call `useCheckoutDeliveryScheduleMetadataDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutDeliveryScheduleMetadataDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutDeliveryScheduleMetadataDeleteMutation, { data, loading, error }] = useCheckoutDeliveryScheduleMetadataDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckoutDeliveryScheduleMetadataDeleteMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppCheckoutDeliveryScheduleMetadataDeleteMutation, OrderAppCheckoutDeliveryScheduleMetadataDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppCheckoutDeliveryScheduleMetadataDeleteMutation, OrderAppCheckoutDeliveryScheduleMetadataDeleteMutationVariables>(CheckoutDeliveryScheduleMetadataDeleteDocument, options);
      }
export type CheckoutDeliveryScheduleMetadataDeleteMutationHookResult = ReturnType<typeof useCheckoutDeliveryScheduleMetadataDeleteMutation>;
export type CheckoutDeliveryScheduleMetadataDeleteMutationResult = Apollo.MutationResult<OrderAppCheckoutDeliveryScheduleMetadataDeleteMutation>;
export type CheckoutDeliveryScheduleMetadataDeleteMutationOptions = Apollo.BaseMutationOptions<OrderAppCheckoutDeliveryScheduleMetadataDeleteMutation, OrderAppCheckoutDeliveryScheduleMetadataDeleteMutationVariables>;
export const CheckoutDeliveryScheduleMetadataUpdateDocument = gql`
    mutation CheckoutDeliveryScheduleMetadataUpdate($id: ID!, $timeSlot: String!) {
  updateMetadata(id: $id, input: [{key: "time_slot", value: $timeSlot}]) {
    errors {
      ...Error
    }
    item {
      ...DeliveryScheduleMetadata
    }
  }
}
    ${ErrorFragmentDoc}
${DeliveryScheduleMetadataFragmentDoc}`;
export type OrderAppCheckoutDeliveryScheduleMetadataUpdateMutationFn = Apollo.MutationFunction<OrderAppCheckoutDeliveryScheduleMetadataUpdateMutation, OrderAppCheckoutDeliveryScheduleMetadataUpdateMutationVariables>;

/**
 * __useCheckoutDeliveryScheduleMetadataUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutDeliveryScheduleMetadataUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutDeliveryScheduleMetadataUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutDeliveryScheduleMetadataUpdateMutation, { data, loading, error }] = useCheckoutDeliveryScheduleMetadataUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      timeSlot: // value for 'timeSlot'
 *   },
 * });
 */
export function useCheckoutDeliveryScheduleMetadataUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppCheckoutDeliveryScheduleMetadataUpdateMutation, OrderAppCheckoutDeliveryScheduleMetadataUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppCheckoutDeliveryScheduleMetadataUpdateMutation, OrderAppCheckoutDeliveryScheduleMetadataUpdateMutationVariables>(CheckoutDeliveryScheduleMetadataUpdateDocument, options);
      }
export type CheckoutDeliveryScheduleMetadataUpdateMutationHookResult = ReturnType<typeof useCheckoutDeliveryScheduleMetadataUpdateMutation>;
export type CheckoutDeliveryScheduleMetadataUpdateMutationResult = Apollo.MutationResult<OrderAppCheckoutDeliveryScheduleMetadataUpdateMutation>;
export type CheckoutDeliveryScheduleMetadataUpdateMutationOptions = Apollo.BaseMutationOptions<OrderAppCheckoutDeliveryScheduleMetadataUpdateMutation, OrderAppCheckoutDeliveryScheduleMetadataUpdateMutationVariables>;
export const CheckoutGwpUpdateDocument = gql`
    mutation checkoutGwpUpdate($id: ID!, $checkoutGwp: CheckoutGwpInput!) {
  gwpCheckoutUpdate(id: $id, checkoutGwp: $checkoutGwp) {
    errors {
      field
      code
      message
    }
  }
}
    `;
export type OrderAppCheckoutGwpUpdateMutationFn = Apollo.MutationFunction<OrderAppCheckoutGwpUpdateMutation, OrderAppCheckoutGwpUpdateMutationVariables>;

/**
 * __useCheckoutGwpUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutGwpUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutGwpUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutGwpUpdateMutation, { data, loading, error }] = useCheckoutGwpUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      checkoutGwp: // value for 'checkoutGwp'
 *   },
 * });
 */
export function useCheckoutGwpUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppCheckoutGwpUpdateMutation, OrderAppCheckoutGwpUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppCheckoutGwpUpdateMutation, OrderAppCheckoutGwpUpdateMutationVariables>(CheckoutGwpUpdateDocument, options);
      }
export type CheckoutGwpUpdateMutationHookResult = ReturnType<typeof useCheckoutGwpUpdateMutation>;
export type CheckoutGwpUpdateMutationResult = Apollo.MutationResult<OrderAppCheckoutGwpUpdateMutation>;
export type CheckoutGwpUpdateMutationOptions = Apollo.BaseMutationOptions<OrderAppCheckoutGwpUpdateMutation, OrderAppCheckoutGwpUpdateMutationVariables>;
export const CheckoutLineBraceletSizeMetadataUpdateDocument = gql`
    mutation CheckoutLineBraceletSizeMetadataUpdate($id: ID!, $braceletSize: String!) {
  updateMetadata(
    id: $id
    input: [{key: "relatedBraceletSize", value: $braceletSize}]
  ) {
    errors {
      ...Error
    }
    item {
      ...CheckoutLineBraceletSizeMetadata
    }
  }
}
    ${ErrorFragmentDoc}
${CheckoutLineBraceletSizeMetadataFragmentDoc}`;
export type OrderAppCheckoutLineBraceletSizeMetadataUpdateMutationFn = Apollo.MutationFunction<OrderAppCheckoutLineBraceletSizeMetadataUpdateMutation, OrderAppCheckoutLineBraceletSizeMetadataUpdateMutationVariables>;

/**
 * __useCheckoutLineBraceletSizeMetadataUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutLineBraceletSizeMetadataUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutLineBraceletSizeMetadataUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutLineBraceletSizeMetadataUpdateMutation, { data, loading, error }] = useCheckoutLineBraceletSizeMetadataUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      braceletSize: // value for 'braceletSize'
 *   },
 * });
 */
export function useCheckoutLineBraceletSizeMetadataUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppCheckoutLineBraceletSizeMetadataUpdateMutation, OrderAppCheckoutLineBraceletSizeMetadataUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppCheckoutLineBraceletSizeMetadataUpdateMutation, OrderAppCheckoutLineBraceletSizeMetadataUpdateMutationVariables>(CheckoutLineBraceletSizeMetadataUpdateDocument, options);
      }
export type CheckoutLineBraceletSizeMetadataUpdateMutationHookResult = ReturnType<typeof useCheckoutLineBraceletSizeMetadataUpdateMutation>;
export type CheckoutLineBraceletSizeMetadataUpdateMutationResult = Apollo.MutationResult<OrderAppCheckoutLineBraceletSizeMetadataUpdateMutation>;
export type CheckoutLineBraceletSizeMetadataUpdateMutationOptions = Apollo.BaseMutationOptions<OrderAppCheckoutLineBraceletSizeMetadataUpdateMutation, OrderAppCheckoutLineBraceletSizeMetadataUpdateMutationVariables>;
export const CheckoutLinesAddDocument = gql`
    mutation CheckoutLinesAdd($id: ID!, $lines: [CheckoutLineInput!]!) {
  checkoutLinesAdd(id: $id, lines: $lines) {
    requiresSocialClubTerms
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type OrderAppCheckoutLinesAddMutationFn = Apollo.MutationFunction<OrderAppCheckoutLinesAddMutation, OrderAppCheckoutLinesAddMutationVariables>;

/**
 * __useCheckoutLinesAddMutation__
 *
 * To run a mutation, you first call `useCheckoutLinesAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutLinesAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutLinesAddMutation, { data, loading, error }] = useCheckoutLinesAddMutation({
 *   variables: {
 *      id: // value for 'id'
 *      lines: // value for 'lines'
 *   },
 * });
 */
export function useCheckoutLinesAddMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppCheckoutLinesAddMutation, OrderAppCheckoutLinesAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppCheckoutLinesAddMutation, OrderAppCheckoutLinesAddMutationVariables>(CheckoutLinesAddDocument, options);
      }
export type CheckoutLinesAddMutationHookResult = ReturnType<typeof useCheckoutLinesAddMutation>;
export type CheckoutLinesAddMutationResult = Apollo.MutationResult<OrderAppCheckoutLinesAddMutation>;
export type CheckoutLinesAddMutationOptions = Apollo.BaseMutationOptions<OrderAppCheckoutLinesAddMutation, OrderAppCheckoutLinesAddMutationVariables>;
export const CheckoutLinesDeleteDocument = gql`
    mutation CheckoutLinesDelete($id: ID!, $linesIds: [ID!]!) {
  checkoutLinesDelete(id: $id, linesIds: $linesIds) {
    requiresSocialClubTerms
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type OrderAppCheckoutLinesDeleteMutationFn = Apollo.MutationFunction<OrderAppCheckoutLinesDeleteMutation, OrderAppCheckoutLinesDeleteMutationVariables>;

/**
 * __useCheckoutLinesDeleteMutation__
 *
 * To run a mutation, you first call `useCheckoutLinesDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutLinesDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutLinesDeleteMutation, { data, loading, error }] = useCheckoutLinesDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      linesIds: // value for 'linesIds'
 *   },
 * });
 */
export function useCheckoutLinesDeleteMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppCheckoutLinesDeleteMutation, OrderAppCheckoutLinesDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppCheckoutLinesDeleteMutation, OrderAppCheckoutLinesDeleteMutationVariables>(CheckoutLinesDeleteDocument, options);
      }
export type CheckoutLinesDeleteMutationHookResult = ReturnType<typeof useCheckoutLinesDeleteMutation>;
export type CheckoutLinesDeleteMutationResult = Apollo.MutationResult<OrderAppCheckoutLinesDeleteMutation>;
export type CheckoutLinesDeleteMutationOptions = Apollo.BaseMutationOptions<OrderAppCheckoutLinesDeleteMutation, OrderAppCheckoutLinesDeleteMutationVariables>;
export const CheckoutVoucherDeleteDocument = gql`
    mutation CheckoutVoucherDelete($id: ID!) {
  checkoutVoucherDelete(id: $id) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type OrderAppCheckoutVoucherDeleteMutationFn = Apollo.MutationFunction<OrderAppCheckoutVoucherDeleteMutation, OrderAppCheckoutVoucherDeleteMutationVariables>;

/**
 * __useCheckoutVoucherDeleteMutation__
 *
 * To run a mutation, you first call `useCheckoutVoucherDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutVoucherDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutVoucherDeleteMutation, { data, loading, error }] = useCheckoutVoucherDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckoutVoucherDeleteMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppCheckoutVoucherDeleteMutation, OrderAppCheckoutVoucherDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppCheckoutVoucherDeleteMutation, OrderAppCheckoutVoucherDeleteMutationVariables>(CheckoutVoucherDeleteDocument, options);
      }
export type CheckoutVoucherDeleteMutationHookResult = ReturnType<typeof useCheckoutVoucherDeleteMutation>;
export type CheckoutVoucherDeleteMutationResult = Apollo.MutationResult<OrderAppCheckoutVoucherDeleteMutation>;
export type CheckoutVoucherDeleteMutationOptions = Apollo.BaseMutationOptions<OrderAppCheckoutVoucherDeleteMutation, OrderAppCheckoutVoucherDeleteMutationVariables>;
export const CheckoutShippingAddressUpdateDocument = gql`
    mutation CheckoutShippingAddressUpdate($id: ID!, $address: AddressInput!, $validationRules: CheckoutAddressValidationRules) {
  checkoutShippingAddressUpdate(
    id: $id
    shippingAddress: $address
    validationRules: $validationRules
  ) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type OrderAppCheckoutShippingAddressUpdateMutationFn = Apollo.MutationFunction<OrderAppCheckoutShippingAddressUpdateMutation, OrderAppCheckoutShippingAddressUpdateMutationVariables>;

/**
 * __useCheckoutShippingAddressUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutShippingAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutShippingAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutShippingAddressUpdateMutation, { data, loading, error }] = useCheckoutShippingAddressUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *      validationRules: // value for 'validationRules'
 *   },
 * });
 */
export function useCheckoutShippingAddressUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppCheckoutShippingAddressUpdateMutation, OrderAppCheckoutShippingAddressUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppCheckoutShippingAddressUpdateMutation, OrderAppCheckoutShippingAddressUpdateMutationVariables>(CheckoutShippingAddressUpdateDocument, options);
      }
export type CheckoutShippingAddressUpdateMutationHookResult = ReturnType<typeof useCheckoutShippingAddressUpdateMutation>;
export type CheckoutShippingAddressUpdateMutationResult = Apollo.MutationResult<OrderAppCheckoutShippingAddressUpdateMutation>;
export type CheckoutShippingAddressUpdateMutationOptions = Apollo.BaseMutationOptions<OrderAppCheckoutShippingAddressUpdateMutation, OrderAppCheckoutShippingAddressUpdateMutationVariables>;
export const DeleteMetadataDocument = gql`
    mutation DeleteMetadata($id: ID!, $keys: [String!]!) {
  deleteMetadata(id: $id, keys: $keys) {
    errors {
      ...Error
    }
    item {
      metadata {
        ...MetadataItem
      }
    }
  }
}
    ${ErrorFragmentDoc}
${MetadataItemFragmentDoc}`;
export type OrderAppDeleteMetadataMutationFn = Apollo.MutationFunction<OrderAppDeleteMetadataMutation, OrderAppDeleteMetadataMutationVariables>;

/**
 * __useDeleteMetadataMutation__
 *
 * To run a mutation, you first call `useDeleteMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMetadataMutation, { data, loading, error }] = useDeleteMetadataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useDeleteMetadataMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppDeleteMetadataMutation, OrderAppDeleteMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppDeleteMetadataMutation, OrderAppDeleteMetadataMutationVariables>(DeleteMetadataDocument, options);
      }
export type DeleteMetadataMutationHookResult = ReturnType<typeof useDeleteMetadataMutation>;
export type DeleteMetadataMutationResult = Apollo.MutationResult<OrderAppDeleteMetadataMutation>;
export type DeleteMetadataMutationOptions = Apollo.BaseMutationOptions<OrderAppDeleteMetadataMutation, OrderAppDeleteMetadataMutationVariables>;
export const GiftMetadataDeleteDocument = gql`
    mutation GiftMetadataDelete($id: ID!) {
  deleteMetadata(id: $id, keys: ["gift", "gift_from", "gift_message"]) {
    errors {
      ...Error
    }
    item {
      ...GiftMetadata
    }
  }
}
    ${ErrorFragmentDoc}
${GiftMetadataFragmentDoc}`;
export type OrderAppGiftMetadataDeleteMutationFn = Apollo.MutationFunction<OrderAppGiftMetadataDeleteMutation, OrderAppGiftMetadataDeleteMutationVariables>;

/**
 * __useGiftMetadataDeleteMutation__
 *
 * To run a mutation, you first call `useGiftMetadataDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiftMetadataDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giftMetadataDeleteMutation, { data, loading, error }] = useGiftMetadataDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGiftMetadataDeleteMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppGiftMetadataDeleteMutation, OrderAppGiftMetadataDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppGiftMetadataDeleteMutation, OrderAppGiftMetadataDeleteMutationVariables>(GiftMetadataDeleteDocument, options);
      }
export type GiftMetadataDeleteMutationHookResult = ReturnType<typeof useGiftMetadataDeleteMutation>;
export type GiftMetadataDeleteMutationResult = Apollo.MutationResult<OrderAppGiftMetadataDeleteMutation>;
export type GiftMetadataDeleteMutationOptions = Apollo.BaseMutationOptions<OrderAppGiftMetadataDeleteMutation, OrderAppGiftMetadataDeleteMutationVariables>;
export const GiftMetadataUpdateDocument = gql`
    mutation GiftMetadataUpdate($id: ID!, $giftFrom: String!, $giftMessage: String!) {
  updateMetadata(
    id: $id
    input: [{key: "gift", value: "true"}, {key: "gift_from", value: $giftFrom}, {key: "gift_message", value: $giftMessage}]
  ) {
    errors {
      ...Error
    }
    item {
      ...GiftMetadata
    }
  }
}
    ${ErrorFragmentDoc}
${GiftMetadataFragmentDoc}`;
export type OrderAppGiftMetadataUpdateMutationFn = Apollo.MutationFunction<OrderAppGiftMetadataUpdateMutation, OrderAppGiftMetadataUpdateMutationVariables>;

/**
 * __useGiftMetadataUpdateMutation__
 *
 * To run a mutation, you first call `useGiftMetadataUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiftMetadataUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giftMetadataUpdateMutation, { data, loading, error }] = useGiftMetadataUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      giftFrom: // value for 'giftFrom'
 *      giftMessage: // value for 'giftMessage'
 *   },
 * });
 */
export function useGiftMetadataUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppGiftMetadataUpdateMutation, OrderAppGiftMetadataUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppGiftMetadataUpdateMutation, OrderAppGiftMetadataUpdateMutationVariables>(GiftMetadataUpdateDocument, options);
      }
export type GiftMetadataUpdateMutationHookResult = ReturnType<typeof useGiftMetadataUpdateMutation>;
export type GiftMetadataUpdateMutationResult = Apollo.MutationResult<OrderAppGiftMetadataUpdateMutation>;
export type GiftMetadataUpdateMutationOptions = Apollo.BaseMutationOptions<OrderAppGiftMetadataUpdateMutation, OrderAppGiftMetadataUpdateMutationVariables>;
export const OfflinePaymentToggleDocument = gql`
    mutation OfflinePaymentToggle($orderId: ID!) {
  offlinePaymentToggle(orderId: $orderId, isOfflinePayment: true) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type OrderAppOfflinePaymentToggleMutationFn = Apollo.MutationFunction<OrderAppOfflinePaymentToggleMutation, OrderAppOfflinePaymentToggleMutationVariables>;

/**
 * __useOfflinePaymentToggleMutation__
 *
 * To run a mutation, you first call `useOfflinePaymentToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfflinePaymentToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offlinePaymentToggleMutation, { data, loading, error }] = useOfflinePaymentToggleMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOfflinePaymentToggleMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppOfflinePaymentToggleMutation, OrderAppOfflinePaymentToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppOfflinePaymentToggleMutation, OrderAppOfflinePaymentToggleMutationVariables>(OfflinePaymentToggleDocument, options);
      }
export type OfflinePaymentToggleMutationHookResult = ReturnType<typeof useOfflinePaymentToggleMutation>;
export type OfflinePaymentToggleMutationResult = Apollo.MutationResult<OrderAppOfflinePaymentToggleMutation>;
export type OfflinePaymentToggleMutationOptions = Apollo.BaseMutationOptions<OrderAppOfflinePaymentToggleMutation, OrderAppOfflinePaymentToggleMutationVariables>;
export const OrderAbandonDocument = gql`
    mutation OrderAbandon($checkoutId: ID!, $orderId: ID!) {
  orderAbandon(checkoutId: $checkoutId, orderId: $orderId) {
    newBusinessId
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type OrderAppOrderAbandonMutationFn = Apollo.MutationFunction<OrderAppOrderAbandonMutation, OrderAppOrderAbandonMutationVariables>;

/**
 * __useOrderAbandonMutation__
 *
 * To run a mutation, you first call `useOrderAbandonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderAbandonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderAbandonMutation, { data, loading, error }] = useOrderAbandonMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useOrderAbandonMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppOrderAbandonMutation, OrderAppOrderAbandonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppOrderAbandonMutation, OrderAppOrderAbandonMutationVariables>(OrderAbandonDocument, options);
      }
export type OrderAbandonMutationHookResult = ReturnType<typeof useOrderAbandonMutation>;
export type OrderAbandonMutationResult = Apollo.MutationResult<OrderAppOrderAbandonMutation>;
export type OrderAbandonMutationOptions = Apollo.BaseMutationOptions<OrderAppOrderAbandonMutation, OrderAppOrderAbandonMutationVariables>;
export const OrderCreateDocument = gql`
    mutation OrderCreate($id: ID!) {
  orderCreate(id: $id) {
    order {
      id
    }
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type OrderAppOrderCreateMutationFn = Apollo.MutationFunction<OrderAppOrderCreateMutation, OrderAppOrderCreateMutationVariables>;

/**
 * __useOrderCreateMutation__
 *
 * To run a mutation, you first call `useOrderCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCreateMutation, { data, loading, error }] = useOrderCreateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderCreateMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppOrderCreateMutation, OrderAppOrderCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppOrderCreateMutation, OrderAppOrderCreateMutationVariables>(OrderCreateDocument, options);
      }
export type OrderCreateMutationHookResult = ReturnType<typeof useOrderCreateMutation>;
export type OrderCreateMutationResult = Apollo.MutationResult<OrderAppOrderCreateMutation>;
export type OrderCreateMutationOptions = Apollo.BaseMutationOptions<OrderAppOrderCreateMutation, OrderAppOrderCreateMutationVariables>;
export const OrderGwpUpdateDocument = gql`
    mutation orderGwpUpdate($id: ID!, $orderGwp: OrderGwpInput!) {
  gwpOrderUpdate(id: $id, orderGwp: $orderGwp) {
    errors {
      field
      code
      message
    }
  }
}
    `;
export type OrderAppOrderGwpUpdateMutationFn = Apollo.MutationFunction<OrderAppOrderGwpUpdateMutation, OrderAppOrderGwpUpdateMutationVariables>;

/**
 * __useOrderGwpUpdateMutation__
 *
 * To run a mutation, you first call `useOrderGwpUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderGwpUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderGwpUpdateMutation, { data, loading, error }] = useOrderGwpUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      orderGwp: // value for 'orderGwp'
 *   },
 * });
 */
export function useOrderGwpUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppOrderGwpUpdateMutation, OrderAppOrderGwpUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppOrderGwpUpdateMutation, OrderAppOrderGwpUpdateMutationVariables>(OrderGwpUpdateDocument, options);
      }
export type OrderGwpUpdateMutationHookResult = ReturnType<typeof useOrderGwpUpdateMutation>;
export type OrderGwpUpdateMutationResult = Apollo.MutationResult<OrderAppOrderGwpUpdateMutation>;
export type OrderGwpUpdateMutationOptions = Apollo.BaseMutationOptions<OrderAppOrderGwpUpdateMutation, OrderAppOrderGwpUpdateMutationVariables>;
export const OrderPayPerLinkTokenCreateDocument = gql`
    mutation OrderPayPerLinkTokenCreate($invitationMethod: InvitationMethod!, $id: ID!) {
  orderSendPaymentInvitation(invitationMethod: $invitationMethod, id: $id) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type OrderAppOrderPayPerLinkTokenCreateMutationFn = Apollo.MutationFunction<OrderAppOrderPayPerLinkTokenCreateMutation, OrderAppOrderPayPerLinkTokenCreateMutationVariables>;

/**
 * __useOrderPayPerLinkTokenCreateMutation__
 *
 * To run a mutation, you first call `useOrderPayPerLinkTokenCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderPayPerLinkTokenCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderPayPerLinkTokenCreateMutation, { data, loading, error }] = useOrderPayPerLinkTokenCreateMutation({
 *   variables: {
 *      invitationMethod: // value for 'invitationMethod'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderPayPerLinkTokenCreateMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppOrderPayPerLinkTokenCreateMutation, OrderAppOrderPayPerLinkTokenCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppOrderPayPerLinkTokenCreateMutation, OrderAppOrderPayPerLinkTokenCreateMutationVariables>(OrderPayPerLinkTokenCreateDocument, options);
      }
export type OrderPayPerLinkTokenCreateMutationHookResult = ReturnType<typeof useOrderPayPerLinkTokenCreateMutation>;
export type OrderPayPerLinkTokenCreateMutationResult = Apollo.MutationResult<OrderAppOrderPayPerLinkTokenCreateMutation>;
export type OrderPayPerLinkTokenCreateMutationOptions = Apollo.BaseMutationOptions<OrderAppOrderPayPerLinkTokenCreateMutation, OrderAppOrderPayPerLinkTokenCreateMutationVariables>;
export const OrderShippingAddressUpdateDocument = gql`
    mutation OrderShippingAddressUpdate($id: ID!, $address: AddressInput!) {
  orderShippingAddressUpdate(id: $id, shippingAddress: $address) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type OrderAppOrderShippingAddressUpdateMutationFn = Apollo.MutationFunction<OrderAppOrderShippingAddressUpdateMutation, OrderAppOrderShippingAddressUpdateMutationVariables>;

/**
 * __useOrderShippingAddressUpdateMutation__
 *
 * To run a mutation, you first call `useOrderShippingAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderShippingAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderShippingAddressUpdateMutation, { data, loading, error }] = useOrderShippingAddressUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useOrderShippingAddressUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppOrderShippingAddressUpdateMutation, OrderAppOrderShippingAddressUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppOrderShippingAddressUpdateMutation, OrderAppOrderShippingAddressUpdateMutationVariables>(OrderShippingAddressUpdateDocument, options);
      }
export type OrderShippingAddressUpdateMutationHookResult = ReturnType<typeof useOrderShippingAddressUpdateMutation>;
export type OrderShippingAddressUpdateMutationResult = Apollo.MutationResult<OrderAppOrderShippingAddressUpdateMutation>;
export type OrderShippingAddressUpdateMutationOptions = Apollo.BaseMutationOptions<OrderAppOrderShippingAddressUpdateMutation, OrderAppOrderShippingAddressUpdateMutationVariables>;
export const OrderUpdateClientDetailsDocument = gql`
    mutation OrderUpdateClientDetails($id: ID!) {
  orderUpdateClientDetails(id: $id) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type OrderAppOrderUpdateClientDetailsMutationFn = Apollo.MutationFunction<OrderAppOrderUpdateClientDetailsMutation, OrderAppOrderUpdateClientDetailsMutationVariables>;

/**
 * __useOrderUpdateClientDetailsMutation__
 *
 * To run a mutation, you first call `useOrderUpdateClientDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderUpdateClientDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderUpdateClientDetailsMutation, { data, loading, error }] = useOrderUpdateClientDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderUpdateClientDetailsMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppOrderUpdateClientDetailsMutation, OrderAppOrderUpdateClientDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppOrderUpdateClientDetailsMutation, OrderAppOrderUpdateClientDetailsMutationVariables>(OrderUpdateClientDetailsDocument, options);
      }
export type OrderUpdateClientDetailsMutationHookResult = ReturnType<typeof useOrderUpdateClientDetailsMutation>;
export type OrderUpdateClientDetailsMutationResult = Apollo.MutationResult<OrderAppOrderUpdateClientDetailsMutation>;
export type OrderUpdateClientDetailsMutationOptions = Apollo.BaseMutationOptions<OrderAppOrderUpdateClientDetailsMutation, OrderAppOrderUpdateClientDetailsMutationVariables>;
export const PaymentMethodMetadataUpdateDocument = gql`
    mutation PaymentMethodMetadataUpdate($id: ID!, $paymentMethod: String!) {
  updateMetadata(id: $id, input: [{key: "paymentMethod", value: $paymentMethod}]) {
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type OrderAppPaymentMethodMetadataUpdateMutationFn = Apollo.MutationFunction<OrderAppPaymentMethodMetadataUpdateMutation, OrderAppPaymentMethodMetadataUpdateMutationVariables>;

/**
 * __usePaymentMethodMetadataUpdateMutation__
 *
 * To run a mutation, you first call `usePaymentMethodMetadataUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodMetadataUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodMetadataUpdateMutation, { data, loading, error }] = usePaymentMethodMetadataUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function usePaymentMethodMetadataUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppPaymentMethodMetadataUpdateMutation, OrderAppPaymentMethodMetadataUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppPaymentMethodMetadataUpdateMutation, OrderAppPaymentMethodMetadataUpdateMutationVariables>(PaymentMethodMetadataUpdateDocument, options);
      }
export type PaymentMethodMetadataUpdateMutationHookResult = ReturnType<typeof usePaymentMethodMetadataUpdateMutation>;
export type PaymentMethodMetadataUpdateMutationResult = Apollo.MutationResult<OrderAppPaymentMethodMetadataUpdateMutation>;
export type PaymentMethodMetadataUpdateMutationOptions = Apollo.BaseMutationOptions<OrderAppPaymentMethodMetadataUpdateMutation, OrderAppPaymentMethodMetadataUpdateMutationVariables>;
export const ProductVariantBusinessDetailsDocument = gql`
    query ProductVariantBusinessDetails($sku: String!, $channel: String!) {
  productVariant(sku: $sku, channel: $channel) {
    ...ProductVariantBusinessDetails
  }
}
    ${ProductVariantBusinessDetailsFragmentDoc}`;

/**
 * __useProductVariantBusinessDetailsQuery__
 *
 * To run a query within a React component, call `useProductVariantBusinessDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantBusinessDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantBusinessDetailsQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useProductVariantBusinessDetailsQuery(baseOptions: Apollo.QueryHookOptions<OrderAppProductVariantBusinessDetailsQuery, OrderAppProductVariantBusinessDetailsQueryVariables> & ({ variables: OrderAppProductVariantBusinessDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAppProductVariantBusinessDetailsQuery, OrderAppProductVariantBusinessDetailsQueryVariables>(ProductVariantBusinessDetailsDocument, options);
      }
export function useProductVariantBusinessDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAppProductVariantBusinessDetailsQuery, OrderAppProductVariantBusinessDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAppProductVariantBusinessDetailsQuery, OrderAppProductVariantBusinessDetailsQueryVariables>(ProductVariantBusinessDetailsDocument, options);
        }
export function useProductVariantBusinessDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAppProductVariantBusinessDetailsQuery, OrderAppProductVariantBusinessDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderAppProductVariantBusinessDetailsQuery, OrderAppProductVariantBusinessDetailsQueryVariables>(ProductVariantBusinessDetailsDocument, options);
        }
export type ProductVariantBusinessDetailsQueryHookResult = ReturnType<typeof useProductVariantBusinessDetailsQuery>;
export type ProductVariantBusinessDetailsLazyQueryHookResult = ReturnType<typeof useProductVariantBusinessDetailsLazyQuery>;
export type ProductVariantBusinessDetailsSuspenseQueryHookResult = ReturnType<typeof useProductVariantBusinessDetailsSuspenseQuery>;
export type ProductVariantBusinessDetailsQueryResult = Apollo.QueryResult<OrderAppProductVariantBusinessDetailsQuery, OrderAppProductVariantBusinessDetailsQueryVariables>;
export const ProductVariantsBusinessDetailsDocument = gql`
    query ProductVariantsBusinessDetails($skus: [String!]!, $channel: String!) {
  productVariants(skus: $skus, channel: $channel) {
    ...ProductVariantBusinessDetails
  }
}
    ${ProductVariantBusinessDetailsFragmentDoc}`;

/**
 * __useProductVariantsBusinessDetailsQuery__
 *
 * To run a query within a React component, call `useProductVariantsBusinessDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantsBusinessDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantsBusinessDetailsQuery({
 *   variables: {
 *      skus: // value for 'skus'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useProductVariantsBusinessDetailsQuery(baseOptions: Apollo.QueryHookOptions<OrderAppProductVariantsBusinessDetailsQuery, OrderAppProductVariantsBusinessDetailsQueryVariables> & ({ variables: OrderAppProductVariantsBusinessDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAppProductVariantsBusinessDetailsQuery, OrderAppProductVariantsBusinessDetailsQueryVariables>(ProductVariantsBusinessDetailsDocument, options);
      }
export function useProductVariantsBusinessDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAppProductVariantsBusinessDetailsQuery, OrderAppProductVariantsBusinessDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAppProductVariantsBusinessDetailsQuery, OrderAppProductVariantsBusinessDetailsQueryVariables>(ProductVariantsBusinessDetailsDocument, options);
        }
export function useProductVariantsBusinessDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAppProductVariantsBusinessDetailsQuery, OrderAppProductVariantsBusinessDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderAppProductVariantsBusinessDetailsQuery, OrderAppProductVariantsBusinessDetailsQueryVariables>(ProductVariantsBusinessDetailsDocument, options);
        }
export type ProductVariantsBusinessDetailsQueryHookResult = ReturnType<typeof useProductVariantsBusinessDetailsQuery>;
export type ProductVariantsBusinessDetailsLazyQueryHookResult = ReturnType<typeof useProductVariantsBusinessDetailsLazyQuery>;
export type ProductVariantsBusinessDetailsSuspenseQueryHookResult = ReturnType<typeof useProductVariantsBusinessDetailsSuspenseQuery>;
export type ProductVariantsBusinessDetailsQueryResult = Apollo.QueryResult<OrderAppProductVariantsBusinessDetailsQuery, OrderAppProductVariantsBusinessDetailsQueryVariables>;
export const UpdateMetadataDocument = gql`
    mutation UpdateMetadata($id: ID!, $input: [MetadataInput!]!) {
  updateMetadata(id: $id, input: $input) {
    errors {
      ...Error
    }
    item {
      metadata {
        ...MetadataItem
      }
    }
  }
}
    ${ErrorFragmentDoc}
${MetadataItemFragmentDoc}`;
export type OrderAppUpdateMetadataMutationFn = Apollo.MutationFunction<OrderAppUpdateMetadataMutation, OrderAppUpdateMetadataMutationVariables>;

/**
 * __useUpdateMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetadataMutation, { data, loading, error }] = useUpdateMetadataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMetadataMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppUpdateMetadataMutation, OrderAppUpdateMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppUpdateMetadataMutation, OrderAppUpdateMetadataMutationVariables>(UpdateMetadataDocument, options);
      }
export type UpdateMetadataMutationHookResult = ReturnType<typeof useUpdateMetadataMutation>;
export type UpdateMetadataMutationResult = Apollo.MutationResult<OrderAppUpdateMetadataMutation>;
export type UpdateMetadataMutationOptions = Apollo.BaseMutationOptions<OrderAppUpdateMetadataMutation, OrderAppUpdateMetadataMutationVariables>;
export const StorefrontWithdrawalSubmitDocument = gql`
    mutation StorefrontWithdrawalSubmit($input: WithdrawalSubmitInput!) {
  withdrawalSubmit(input: $input) {
    withdrawalSubmit {
      code
      withdrawalRequestId
      submittedAt
      items {
        orderLineId
        quantity
        reasonCode
        translatedReason
        comment
        status
      }
    }
    errors {
      code
      message
      field
      context
    }
  }
}
    `;
export type OrderAppStorefrontWithdrawalSubmitMutationFn = Apollo.MutationFunction<OrderAppStorefrontWithdrawalSubmitMutation, OrderAppStorefrontWithdrawalSubmitMutationVariables>;

/**
 * __useStorefrontWithdrawalSubmitMutation__
 *
 * To run a mutation, you first call `useStorefrontWithdrawalSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontWithdrawalSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontWithdrawalSubmitMutation, { data, loading, error }] = useStorefrontWithdrawalSubmitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStorefrontWithdrawalSubmitMutation(baseOptions?: Apollo.MutationHookOptions<OrderAppStorefrontWithdrawalSubmitMutation, OrderAppStorefrontWithdrawalSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderAppStorefrontWithdrawalSubmitMutation, OrderAppStorefrontWithdrawalSubmitMutationVariables>(StorefrontWithdrawalSubmitDocument, options);
      }
export type StorefrontWithdrawalSubmitMutationHookResult = ReturnType<typeof useStorefrontWithdrawalSubmitMutation>;
export type StorefrontWithdrawalSubmitMutationResult = Apollo.MutationResult<OrderAppStorefrontWithdrawalSubmitMutation>;
export type StorefrontWithdrawalSubmitMutationOptions = Apollo.BaseMutationOptions<OrderAppStorefrontWithdrawalSubmitMutation, OrderAppStorefrontWithdrawalSubmitMutationVariables>;
export const BillingCountriesDocument = gql`
    query BillingCountries {
  billingCountries {
    ...BillingCountry
  }
}
    ${BillingCountryFragmentDoc}`;

/**
 * __useBillingCountriesQuery__
 *
 * To run a query within a React component, call `useBillingCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillingCountriesQuery(baseOptions?: Apollo.QueryHookOptions<OrderAppBillingCountriesQuery, OrderAppBillingCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAppBillingCountriesQuery, OrderAppBillingCountriesQueryVariables>(BillingCountriesDocument, options);
      }
export function useBillingCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAppBillingCountriesQuery, OrderAppBillingCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAppBillingCountriesQuery, OrderAppBillingCountriesQueryVariables>(BillingCountriesDocument, options);
        }
export function useBillingCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAppBillingCountriesQuery, OrderAppBillingCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderAppBillingCountriesQuery, OrderAppBillingCountriesQueryVariables>(BillingCountriesDocument, options);
        }
export type BillingCountriesQueryHookResult = ReturnType<typeof useBillingCountriesQuery>;
export type BillingCountriesLazyQueryHookResult = ReturnType<typeof useBillingCountriesLazyQuery>;
export type BillingCountriesSuspenseQueryHookResult = ReturnType<typeof useBillingCountriesSuspenseQuery>;
export type BillingCountriesQueryResult = Apollo.QueryResult<OrderAppBillingCountriesQuery, OrderAppBillingCountriesQueryVariables>;
export const CheckoutChannelConfigDocument = gql`
    query CheckoutChannelConfig($channel: String!) {
  channelConfig(channel: $channel) {
    deliveryModes
  }
}
    `;

/**
 * __useCheckoutChannelConfigQuery__
 *
 * To run a query within a React component, call `useCheckoutChannelConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutChannelConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutChannelConfigQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useCheckoutChannelConfigQuery(baseOptions: Apollo.QueryHookOptions<OrderAppCheckoutChannelConfigQuery, OrderAppCheckoutChannelConfigQueryVariables> & ({ variables: OrderAppCheckoutChannelConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAppCheckoutChannelConfigQuery, OrderAppCheckoutChannelConfigQueryVariables>(CheckoutChannelConfigDocument, options);
      }
export function useCheckoutChannelConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAppCheckoutChannelConfigQuery, OrderAppCheckoutChannelConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAppCheckoutChannelConfigQuery, OrderAppCheckoutChannelConfigQueryVariables>(CheckoutChannelConfigDocument, options);
        }
export function useCheckoutChannelConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAppCheckoutChannelConfigQuery, OrderAppCheckoutChannelConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderAppCheckoutChannelConfigQuery, OrderAppCheckoutChannelConfigQueryVariables>(CheckoutChannelConfigDocument, options);
        }
export type CheckoutChannelConfigQueryHookResult = ReturnType<typeof useCheckoutChannelConfigQuery>;
export type CheckoutChannelConfigLazyQueryHookResult = ReturnType<typeof useCheckoutChannelConfigLazyQuery>;
export type CheckoutChannelConfigSuspenseQueryHookResult = ReturnType<typeof useCheckoutChannelConfigSuspenseQuery>;
export type CheckoutChannelConfigQueryResult = Apollo.QueryResult<OrderAppCheckoutChannelConfigQuery, OrderAppCheckoutChannelConfigQueryVariables>;
export const GwpProductsDocument = gql`
    query gwpProducts($checkout_id: String!, $channel: String, $thresh_hold: String, $brand: String) {
  gwpProducts(
    checkout_id: $checkout_id
    channel: $channel
    thresh_hold: $thresh_hold
    brand: $brand
  ) {
    slug
    id
    name
    available_quantity
    product_type_slug
    threshhold
    thumbnail_alt
    thumbnail_url
  }
}
    `;

/**
 * __useGwpProductsQuery__
 *
 * To run a query within a React component, call `useGwpProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGwpProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGwpProductsQuery({
 *   variables: {
 *      checkout_id: // value for 'checkout_id'
 *      channel: // value for 'channel'
 *      thresh_hold: // value for 'thresh_hold'
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useGwpProductsQuery(baseOptions: Apollo.QueryHookOptions<OrderAppGwpProductsQuery, OrderAppGwpProductsQueryVariables> & ({ variables: OrderAppGwpProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAppGwpProductsQuery, OrderAppGwpProductsQueryVariables>(GwpProductsDocument, options);
      }
export function useGwpProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAppGwpProductsQuery, OrderAppGwpProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAppGwpProductsQuery, OrderAppGwpProductsQueryVariables>(GwpProductsDocument, options);
        }
export function useGwpProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAppGwpProductsQuery, OrderAppGwpProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderAppGwpProductsQuery, OrderAppGwpProductsQueryVariables>(GwpProductsDocument, options);
        }
export type GwpProductsQueryHookResult = ReturnType<typeof useGwpProductsQuery>;
export type GwpProductsLazyQueryHookResult = ReturnType<typeof useGwpProductsLazyQuery>;
export type GwpProductsSuspenseQueryHookResult = ReturnType<typeof useGwpProductsSuspenseQuery>;
export type GwpProductsQueryResult = Apollo.QueryResult<OrderAppGwpProductsQuery, OrderAppGwpProductsQueryVariables>;
export const OfflinePaymentAvailabilityDocument = gql`
    query OfflinePaymentAvailability($id: ID!) {
  storefrontOfflinePaymentAvailability(id: $id)
}
    `;

/**
 * __useOfflinePaymentAvailabilityQuery__
 *
 * To run a query within a React component, call `useOfflinePaymentAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfflinePaymentAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfflinePaymentAvailabilityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOfflinePaymentAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<OrderAppOfflinePaymentAvailabilityQuery, OrderAppOfflinePaymentAvailabilityQueryVariables> & ({ variables: OrderAppOfflinePaymentAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAppOfflinePaymentAvailabilityQuery, OrderAppOfflinePaymentAvailabilityQueryVariables>(OfflinePaymentAvailabilityDocument, options);
      }
export function useOfflinePaymentAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAppOfflinePaymentAvailabilityQuery, OrderAppOfflinePaymentAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAppOfflinePaymentAvailabilityQuery, OrderAppOfflinePaymentAvailabilityQueryVariables>(OfflinePaymentAvailabilityDocument, options);
        }
export function useOfflinePaymentAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAppOfflinePaymentAvailabilityQuery, OrderAppOfflinePaymentAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderAppOfflinePaymentAvailabilityQuery, OrderAppOfflinePaymentAvailabilityQueryVariables>(OfflinePaymentAvailabilityDocument, options);
        }
export type OfflinePaymentAvailabilityQueryHookResult = ReturnType<typeof useOfflinePaymentAvailabilityQuery>;
export type OfflinePaymentAvailabilityLazyQueryHookResult = ReturnType<typeof useOfflinePaymentAvailabilityLazyQuery>;
export type OfflinePaymentAvailabilitySuspenseQueryHookResult = ReturnType<typeof useOfflinePaymentAvailabilitySuspenseQuery>;
export type OfflinePaymentAvailabilityQueryResult = Apollo.QueryResult<OrderAppOfflinePaymentAvailabilityQuery, OrderAppOfflinePaymentAvailabilityQueryVariables>;
export const OrderExtraDataDocument = gql`
    query OrderExtraData($id: ID!) {
  order(id: $id) {
    ...OrderExtraData
  }
}
    ${OrderExtraDataFragmentDoc}`;

/**
 * __useOrderExtraDataQuery__
 *
 * To run a query within a React component, call `useOrderExtraDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderExtraDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderExtraDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderExtraDataQuery(baseOptions: Apollo.QueryHookOptions<OrderAppOrderExtraDataQuery, OrderAppOrderExtraDataQueryVariables> & ({ variables: OrderAppOrderExtraDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAppOrderExtraDataQuery, OrderAppOrderExtraDataQueryVariables>(OrderExtraDataDocument, options);
      }
export function useOrderExtraDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAppOrderExtraDataQuery, OrderAppOrderExtraDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAppOrderExtraDataQuery, OrderAppOrderExtraDataQueryVariables>(OrderExtraDataDocument, options);
        }
export function useOrderExtraDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAppOrderExtraDataQuery, OrderAppOrderExtraDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderAppOrderExtraDataQuery, OrderAppOrderExtraDataQueryVariables>(OrderExtraDataDocument, options);
        }
export type OrderExtraDataQueryHookResult = ReturnType<typeof useOrderExtraDataQuery>;
export type OrderExtraDataLazyQueryHookResult = ReturnType<typeof useOrderExtraDataLazyQuery>;
export type OrderExtraDataSuspenseQueryHookResult = ReturnType<typeof useOrderExtraDataSuspenseQuery>;
export type OrderExtraDataQueryResult = Apollo.QueryResult<OrderAppOrderExtraDataQuery, OrderAppOrderExtraDataQueryVariables>;
export const OrderIdByBusinessIdAndEmailDocument = gql`
    query OrderIdByBusinessIdAndEmail($businessId: String!, $email: String!, $recaptchaToken: String!) {
  orderIdByBusinessIdAndEmail(
    businessId: $businessId
    email: $email
    recaptchaToken: $recaptchaToken
  ) {
    id
  }
}
    `;

/**
 * __useOrderIdByBusinessIdAndEmailQuery__
 *
 * To run a query within a React component, call `useOrderIdByBusinessIdAndEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderIdByBusinessIdAndEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderIdByBusinessIdAndEmailQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      email: // value for 'email'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useOrderIdByBusinessIdAndEmailQuery(baseOptions: Apollo.QueryHookOptions<OrderAppOrderIdByBusinessIdAndEmailQuery, OrderAppOrderIdByBusinessIdAndEmailQueryVariables> & ({ variables: OrderAppOrderIdByBusinessIdAndEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAppOrderIdByBusinessIdAndEmailQuery, OrderAppOrderIdByBusinessIdAndEmailQueryVariables>(OrderIdByBusinessIdAndEmailDocument, options);
      }
export function useOrderIdByBusinessIdAndEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAppOrderIdByBusinessIdAndEmailQuery, OrderAppOrderIdByBusinessIdAndEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAppOrderIdByBusinessIdAndEmailQuery, OrderAppOrderIdByBusinessIdAndEmailQueryVariables>(OrderIdByBusinessIdAndEmailDocument, options);
        }
export function useOrderIdByBusinessIdAndEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAppOrderIdByBusinessIdAndEmailQuery, OrderAppOrderIdByBusinessIdAndEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderAppOrderIdByBusinessIdAndEmailQuery, OrderAppOrderIdByBusinessIdAndEmailQueryVariables>(OrderIdByBusinessIdAndEmailDocument, options);
        }
export type OrderIdByBusinessIdAndEmailQueryHookResult = ReturnType<typeof useOrderIdByBusinessIdAndEmailQuery>;
export type OrderIdByBusinessIdAndEmailLazyQueryHookResult = ReturnType<typeof useOrderIdByBusinessIdAndEmailLazyQuery>;
export type OrderIdByBusinessIdAndEmailSuspenseQueryHookResult = ReturnType<typeof useOrderIdByBusinessIdAndEmailSuspenseQuery>;
export type OrderIdByBusinessIdAndEmailQueryResult = Apollo.QueryResult<OrderAppOrderIdByBusinessIdAndEmailQuery, OrderAppOrderIdByBusinessIdAndEmailQueryVariables>;
export const PayPerLinkOrderExtraDataDocument = gql`
    query PayPerLinkOrderExtraData($token: String!) {
  orderByPaymentToken(token: $token) {
    ...PayPerLinkOrderExtraData
  }
}
    ${PayPerLinkOrderExtraDataFragmentDoc}`;

/**
 * __usePayPerLinkOrderExtraDataQuery__
 *
 * To run a query within a React component, call `usePayPerLinkOrderExtraDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayPerLinkOrderExtraDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayPerLinkOrderExtraDataQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePayPerLinkOrderExtraDataQuery(baseOptions: Apollo.QueryHookOptions<OrderAppPayPerLinkOrderExtraDataQuery, OrderAppPayPerLinkOrderExtraDataQueryVariables> & ({ variables: OrderAppPayPerLinkOrderExtraDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAppPayPerLinkOrderExtraDataQuery, OrderAppPayPerLinkOrderExtraDataQueryVariables>(PayPerLinkOrderExtraDataDocument, options);
      }
export function usePayPerLinkOrderExtraDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAppPayPerLinkOrderExtraDataQuery, OrderAppPayPerLinkOrderExtraDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAppPayPerLinkOrderExtraDataQuery, OrderAppPayPerLinkOrderExtraDataQueryVariables>(PayPerLinkOrderExtraDataDocument, options);
        }
export function usePayPerLinkOrderExtraDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAppPayPerLinkOrderExtraDataQuery, OrderAppPayPerLinkOrderExtraDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderAppPayPerLinkOrderExtraDataQuery, OrderAppPayPerLinkOrderExtraDataQueryVariables>(PayPerLinkOrderExtraDataDocument, options);
        }
export type PayPerLinkOrderExtraDataQueryHookResult = ReturnType<typeof usePayPerLinkOrderExtraDataQuery>;
export type PayPerLinkOrderExtraDataLazyQueryHookResult = ReturnType<typeof usePayPerLinkOrderExtraDataLazyQuery>;
export type PayPerLinkOrderExtraDataSuspenseQueryHookResult = ReturnType<typeof usePayPerLinkOrderExtraDataSuspenseQuery>;
export type PayPerLinkOrderExtraDataQueryResult = Apollo.QueryResult<OrderAppPayPerLinkOrderExtraDataQuery, OrderAppPayPerLinkOrderExtraDataQueryVariables>;
export const StorefrontReturnReasonsDocument = gql`
    query StorefrontReturnReasons {
  returnReasons {
    id
    audiences
    translations {
      languageCode
      value
    }
  }
}
    `;

/**
 * __useStorefrontReturnReasonsQuery__
 *
 * To run a query within a React component, call `useStorefrontReturnReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontReturnReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontReturnReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStorefrontReturnReasonsQuery(baseOptions?: Apollo.QueryHookOptions<OrderAppStorefrontReturnReasonsQuery, OrderAppStorefrontReturnReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAppStorefrontReturnReasonsQuery, OrderAppStorefrontReturnReasonsQueryVariables>(StorefrontReturnReasonsDocument, options);
      }
export function useStorefrontReturnReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAppStorefrontReturnReasonsQuery, OrderAppStorefrontReturnReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAppStorefrontReturnReasonsQuery, OrderAppStorefrontReturnReasonsQueryVariables>(StorefrontReturnReasonsDocument, options);
        }
export function useStorefrontReturnReasonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAppStorefrontReturnReasonsQuery, OrderAppStorefrontReturnReasonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderAppStorefrontReturnReasonsQuery, OrderAppStorefrontReturnReasonsQueryVariables>(StorefrontReturnReasonsDocument, options);
        }
export type StorefrontReturnReasonsQueryHookResult = ReturnType<typeof useStorefrontReturnReasonsQuery>;
export type StorefrontReturnReasonsLazyQueryHookResult = ReturnType<typeof useStorefrontReturnReasonsLazyQuery>;
export type StorefrontReturnReasonsSuspenseQueryHookResult = ReturnType<typeof useStorefrontReturnReasonsSuspenseQuery>;
export type StorefrontReturnReasonsQueryResult = Apollo.QueryResult<OrderAppStorefrontReturnReasonsQuery, OrderAppStorefrontReturnReasonsQueryVariables>;
export const ValidateCheckoutDocument = gql`
    query ValidateCheckout($id: ID!, $checkPrices: Boolean, $checkStocks: Boolean, $checkAddress: Boolean) {
  validateCheckout(
    id: $id
    checkPrices: $checkPrices
    checkStocks: $checkStocks
    checkAddress: $checkAddress
  ) {
    checkoutId
    valid
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;

/**
 * __useValidateCheckoutQuery__
 *
 * To run a query within a React component, call `useValidateCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCheckoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *      checkPrices: // value for 'checkPrices'
 *      checkStocks: // value for 'checkStocks'
 *      checkAddress: // value for 'checkAddress'
 *   },
 * });
 */
export function useValidateCheckoutQuery(baseOptions: Apollo.QueryHookOptions<OrderAppValidateCheckoutQuery, OrderAppValidateCheckoutQueryVariables> & ({ variables: OrderAppValidateCheckoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAppValidateCheckoutQuery, OrderAppValidateCheckoutQueryVariables>(ValidateCheckoutDocument, options);
      }
export function useValidateCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAppValidateCheckoutQuery, OrderAppValidateCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAppValidateCheckoutQuery, OrderAppValidateCheckoutQueryVariables>(ValidateCheckoutDocument, options);
        }
export function useValidateCheckoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAppValidateCheckoutQuery, OrderAppValidateCheckoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderAppValidateCheckoutQuery, OrderAppValidateCheckoutQueryVariables>(ValidateCheckoutDocument, options);
        }
export type ValidateCheckoutQueryHookResult = ReturnType<typeof useValidateCheckoutQuery>;
export type ValidateCheckoutLazyQueryHookResult = ReturnType<typeof useValidateCheckoutLazyQuery>;
export type ValidateCheckoutSuspenseQueryHookResult = ReturnType<typeof useValidateCheckoutSuspenseQuery>;
export type ValidateCheckoutQueryResult = Apollo.QueryResult<OrderAppValidateCheckoutQuery, OrderAppValidateCheckoutQueryVariables>;
export const GetVoucherDocument = gql`
    query getVoucher($code: String!, $channel: String!) {
  voucher(code: $code, channel: $channel) {
    type
    discountValueType
  }
}
    `;

/**
 * __useGetVoucherQuery__
 *
 * To run a query within a React component, call `useGetVoucherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoucherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoucherQuery({
 *   variables: {
 *      code: // value for 'code'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useGetVoucherQuery(baseOptions: Apollo.QueryHookOptions<OrderAppGetVoucherQuery, OrderAppGetVoucherQueryVariables> & ({ variables: OrderAppGetVoucherQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAppGetVoucherQuery, OrderAppGetVoucherQueryVariables>(GetVoucherDocument, options);
      }
export function useGetVoucherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAppGetVoucherQuery, OrderAppGetVoucherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAppGetVoucherQuery, OrderAppGetVoucherQueryVariables>(GetVoucherDocument, options);
        }
export function useGetVoucherSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAppGetVoucherQuery, OrderAppGetVoucherQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderAppGetVoucherQuery, OrderAppGetVoucherQueryVariables>(GetVoucherDocument, options);
        }
export type GetVoucherQueryHookResult = ReturnType<typeof useGetVoucherQuery>;
export type GetVoucherLazyQueryHookResult = ReturnType<typeof useGetVoucherLazyQuery>;
export type GetVoucherSuspenseQueryHookResult = ReturnType<typeof useGetVoucherSuspenseQuery>;
export type GetVoucherQueryResult = Apollo.QueryResult<OrderAppGetVoucherQuery, OrderAppGetVoucherQueryVariables>;
export const StorefrontWithdrawalEligibilityDocument = gql`
    query StorefrontWithdrawalEligibility($input: WithdrawalEligibilityInput!) {
  withdrawalEligibility(input: $input) {
    withdrawal {
      code
      accessMode
      customer {
        email
        firstName
        lastName
      }
      order {
        id
        businessId
        status
        createdAt
        channel
      }
      lines {
        orderLineId
        productName
        sku
        quantity
        eligibleQuantity
        status
        disabledReasonCode
        referenceDate
        referenceDateSource
        windowEndAt
      }
    }
    errors {
      code
      message
    }
  }
}
    `;

/**
 * __useStorefrontWithdrawalEligibilityQuery__
 *
 * To run a query within a React component, call `useStorefrontWithdrawalEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontWithdrawalEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontWithdrawalEligibilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStorefrontWithdrawalEligibilityQuery(baseOptions: Apollo.QueryHookOptions<OrderAppStorefrontWithdrawalEligibilityQuery, OrderAppStorefrontWithdrawalEligibilityQueryVariables> & ({ variables: OrderAppStorefrontWithdrawalEligibilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAppStorefrontWithdrawalEligibilityQuery, OrderAppStorefrontWithdrawalEligibilityQueryVariables>(StorefrontWithdrawalEligibilityDocument, options);
      }
export function useStorefrontWithdrawalEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAppStorefrontWithdrawalEligibilityQuery, OrderAppStorefrontWithdrawalEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAppStorefrontWithdrawalEligibilityQuery, OrderAppStorefrontWithdrawalEligibilityQueryVariables>(StorefrontWithdrawalEligibilityDocument, options);
        }
export function useStorefrontWithdrawalEligibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAppStorefrontWithdrawalEligibilityQuery, OrderAppStorefrontWithdrawalEligibilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderAppStorefrontWithdrawalEligibilityQuery, OrderAppStorefrontWithdrawalEligibilityQueryVariables>(StorefrontWithdrawalEligibilityDocument, options);
        }
export type StorefrontWithdrawalEligibilityQueryHookResult = ReturnType<typeof useStorefrontWithdrawalEligibilityQuery>;
export type StorefrontWithdrawalEligibilityLazyQueryHookResult = ReturnType<typeof useStorefrontWithdrawalEligibilityLazyQuery>;
export type StorefrontWithdrawalEligibilitySuspenseQueryHookResult = ReturnType<typeof useStorefrontWithdrawalEligibilitySuspenseQuery>;
export type StorefrontWithdrawalEligibilityQueryResult = Apollo.QueryResult<OrderAppStorefrontWithdrawalEligibilityQuery, OrderAppStorefrontWithdrawalEligibilityQueryVariables>;
export const OrderValidationDocument = gql`
    query OrderValidation($id: ID!) {
  validateOrder(id: $id) {
    id
    valid
    errors {
      ...Error
    }
  }
}
    ${ErrorFragmentDoc}`;

/**
 * __useOrderValidationQuery__
 *
 * To run a query within a React component, call `useOrderValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderValidationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderValidationQuery(baseOptions: Apollo.QueryHookOptions<OrderAppOrderValidationQuery, OrderAppOrderValidationQueryVariables> & ({ variables: OrderAppOrderValidationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderAppOrderValidationQuery, OrderAppOrderValidationQueryVariables>(OrderValidationDocument, options);
      }
export function useOrderValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderAppOrderValidationQuery, OrderAppOrderValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderAppOrderValidationQuery, OrderAppOrderValidationQueryVariables>(OrderValidationDocument, options);
        }
export function useOrderValidationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderAppOrderValidationQuery, OrderAppOrderValidationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderAppOrderValidationQuery, OrderAppOrderValidationQueryVariables>(OrderValidationDocument, options);
        }
export type OrderValidationQueryHookResult = ReturnType<typeof useOrderValidationQuery>;
export type OrderValidationLazyQueryHookResult = ReturnType<typeof useOrderValidationLazyQuery>;
export type OrderValidationSuspenseQueryHookResult = ReturnType<typeof useOrderValidationSuspenseQuery>;
export type OrderValidationQueryResult = Apollo.QueryResult<OrderAppOrderValidationQuery, OrderAppOrderValidationQueryVariables>;
export type AddressKeySpecifier = ('city' | 'cityArea' | 'companyName' | 'country' | 'countryArea' | 'firstName' | 'lastName' | 'postalCode' | 'streetAddress1' | 'streetAddress2' | AddressKeySpecifier)[];
export type AddressFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	cityArea?: FieldPolicy<any> | FieldReadFunction<any>,
	companyName?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	countryArea?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	streetAddress1?: FieldPolicy<any> | FieldReadFunction<any>,
	streetAddress2?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeKeySpecifier = ('slug' | AttributeKeySpecifier)[];
export type AttributeFieldPolicy = {
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueKeySpecifier = ('name' | 'translation' | AttributeValueKeySpecifier)[];
export type AttributeValueFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueTranslationKeySpecifier = ('name' | AttributeValueTranslationKeySpecifier)[];
export type AttributeValueTranslationFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BillingCountryKeySpecifier = ('code' | 'name' | BillingCountryKeySpecifier)[];
export type BillingCountryFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryKeySpecifier = ('id' | 'name' | CategoryKeySpecifier)[];
export type CategoryFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelKeySpecifier = ('currencyCode' | 'id' | 'slug' | ChannelKeySpecifier)[];
export type ChannelFieldPolicy = {
	currencyCode?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelConfigKeySpecifier = ('defaultDeliveryMethod' | 'deliveryModes' | ChannelConfigKeySpecifier)[];
export type ChannelConfigFieldPolicy = {
	defaultDeliveryMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryModes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutKeySpecifier = ('billingAddress' | 'channel' | 'deliveryMethod' | 'email' | 'id' | 'languageCode' | 'lines' | 'shippingAddress' | 'user' | CheckoutKeySpecifier)[];
export type CheckoutFieldPolicy = {
	billingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	languageCode?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutCreateKeySpecifier = ('checkout' | 'errors' | CheckoutCreateKeySpecifier)[];
export type CheckoutCreateFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutCreateCheckoutKeySpecifier = ('email' | 'id' | 'user' | CheckoutCreateCheckoutKeySpecifier)[];
export type CheckoutCreateCheckoutFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutCreateUserKeySpecifier = ('email' | CheckoutCreateUserKeySpecifier)[];
export type CheckoutCreateUserFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutGwpUpdateResultKeySpecifier = ('errors' | CheckoutGwpUpdateResultKeySpecifier)[];
export type CheckoutGwpUpdateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutLineKeySpecifier = ('hasWarrantyExtension' | 'id' | 'metadata' | 'quantity' | 'requiresShipping' | 'strapPackReference' | 'strapReference' | 'totalPrice' | 'undiscountedUnitPrice' | 'unitPrice' | 'variant' | 'warrantyExtensionDuration' | 'warrantyExtensionId' | 'watchLineId' | CheckoutLineKeySpecifier)[];
export type CheckoutLineFieldPolicy = {
	hasWarrantyExtension?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	requiresShipping?: FieldPolicy<any> | FieldReadFunction<any>,
	strapPackReference?: FieldPolicy<any> | FieldReadFunction<any>,
	strapReference?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	undiscountedUnitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>,
	warrantyExtensionDuration?: FieldPolicy<any> | FieldReadFunction<any>,
	warrantyExtensionId?: FieldPolicy<any> | FieldReadFunction<any>,
	watchLineId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutLinesAddResultKeySpecifier = ('errors' | CheckoutLinesAddResultKeySpecifier)[];
export type CheckoutLinesAddResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutLinesDeleteResultKeySpecifier = ('errors' | CheckoutLinesDeleteResultKeySpecifier)[];
export type CheckoutLinesDeleteResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutShippingAddressUpdateResultKeySpecifier = ('errors' | CheckoutShippingAddressUpdateResultKeySpecifier)[];
export type CheckoutShippingAddressUpdateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutValidationResultKeySpecifier = ('checkoutId' | 'errors' | 'valid' | CheckoutValidationResultKeySpecifier)[];
export type CheckoutValidationResultFieldPolicy = {
	checkoutId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	valid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutVoucherAddResultKeySpecifier = ('checkout' | 'errors' | CheckoutVoucherAddResultKeySpecifier)[];
export type CheckoutVoucherAddResultFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutVoucherDeleteResultKeySpecifier = ('checkout' | 'errors' | CheckoutVoucherDeleteResultKeySpecifier)[];
export type CheckoutVoucherDeleteResultFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CountryChannelKeySpecifier = ('channel' | 'name' | CountryChannelKeySpecifier)[];
export type CountryChannelFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CountryDisplayKeySpecifier = ('code' | 'country' | CountryDisplayKeySpecifier)[];
export type CountryDisplayFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteMetadataKeySpecifier = ('errors' | 'item' | DeleteMetadataKeySpecifier)[];
export type DeleteMetadataFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryMethodKeySpecifier = ('id' | 'type' | DeliveryMethodKeySpecifier)[];
export type DeliveryMethodFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeliveryModeUpdateResultKeySpecifier = ('errors' | DeliveryModeUpdateResultKeySpecifier)[];
export type DeliveryModeUpdateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderKeySpecifier = ('businessId' | 'channel' | 'id' | DraftOrderKeySpecifier)[];
export type DraftOrderFieldPolicy = {
	businessId?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderCompleteResultKeySpecifier = ('errors' | 'order' | DraftOrderCompleteResultKeySpecifier)[];
export type DraftOrderCompleteResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderCreateResultKeySpecifier = ('errors' | 'order' | DraftOrderCreateResultKeySpecifier)[];
export type DraftOrderCreateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ErrorKeySpecifier = ('code' | 'context' | 'field' | 'message' | ErrorKeySpecifier)[];
export type ErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	context?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GwpProductKeySpecifier = ('available_quantity' | 'id' | 'name' | 'product_type_slug' | 'slug' | 'threshhold' | 'thumbnail_alt' | 'thumbnail_url' | GwpProductKeySpecifier)[];
export type GwpProductFieldPolicy = {
	available_quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	product_type_slug?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	threshhold?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail_alt?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail_url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IdOnlyOrderKeySpecifier = ('id' | IdOnlyOrderKeySpecifier)[];
export type IdOnlyOrderFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageKeySpecifier = ('alt' | 'url' | ImageKeySpecifier)[];
export type ImageFieldPolicy = {
	alt?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarketSellableKeySpecifier = ('market' | 'sellable' | 'sellingType' | MarketSellableKeySpecifier)[];
export type MarketSellableFieldPolicy = {
	market?: FieldPolicy<any> | FieldReadFunction<any>,
	sellable?: FieldPolicy<any> | FieldReadFunction<any>,
	sellingType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarketVisibleKeySpecifier = ('market' | 'visible' | MarketVisibleKeySpecifier)[];
export type MarketVisibleFieldPolicy = {
	market?: FieldPolicy<any> | FieldReadFunction<any>,
	visible?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetadataItemKeySpecifier = ('key' | 'value' | MetadataItemKeySpecifier)[];
export type MetadataItemFieldPolicy = {
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoneyKeySpecifier = ('amount' | 'currency' | MoneyKeySpecifier)[];
export type MoneyFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('checkoutCreate' | 'checkoutLinesAdd' | 'checkoutLinesDelete' | 'checkoutShippingAddressUpdate' | 'checkoutVoucherAdd' | 'checkoutVoucherDelete' | 'deleteMetadata' | 'deliveryModeUpdate' | 'draftOrderComplete' | 'draftOrderCreate' | 'editSetting' | 'gwpCheckoutUpdate' | 'gwpOrderUpdate' | 'offlinePaymentConfirm' | 'offlinePaymentEmailDetails' | 'offlinePaymentToggle' | 'orderAbandon' | 'orderCancel' | 'orderCreate' | 'orderDiscountAdd' | 'orderFreeShippingAdd' | 'orderGenerateBusinessId' | 'orderGenerateInvoice' | 'orderLineDelete' | 'orderLineDiscountRemove' | 'orderLineDiscountUpdate' | 'orderLinesCreate' | 'orderReturnCancel' | 'orderReturnCreate' | 'orderReturnReject' | 'orderSendPaymentInvitation' | 'orderShippingAddressUpdate' | 'orderUpdateClientDetails' | 'orderVoucherAdd' | 'orderVoucherDelete' | 'paymentCaptureRetry' | 'productVariantBulkUpdate' | 'productVariantUpdate' | 'refundCreate' | 'rerouteFulfillmentLocation' | 'resendReturnLabel' | 'sendInvoice' | 'shippingUpdate' | 'subscriptionUpdate' | 'updateEngravingInfo' | 'updateMetadata' | 'withdrawalSubmit' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	checkoutCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutLinesAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutLinesDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutShippingAddressUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutVoucherAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutVoucherDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryModeUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	editSetting?: FieldPolicy<any> | FieldReadFunction<any>,
	gwpCheckoutUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	gwpOrderUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	offlinePaymentConfirm?: FieldPolicy<any> | FieldReadFunction<any>,
	offlinePaymentEmailDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	offlinePaymentToggle?: FieldPolicy<any> | FieldReadFunction<any>,
	orderAbandon?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderDiscountAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	orderFreeShippingAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	orderGenerateBusinessId?: FieldPolicy<any> | FieldReadFunction<any>,
	orderGenerateInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLineDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLineDiscountRemove?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLineDiscountUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLinesCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderReturnCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	orderReturnCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderReturnReject?: FieldPolicy<any> | FieldReadFunction<any>,
	orderSendPaymentInvitation?: FieldPolicy<any> | FieldReadFunction<any>,
	orderShippingAddressUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderUpdateClientDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	orderVoucherAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	orderVoucherDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentCaptureRetry?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantBulkUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	refundCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	rerouteFulfillmentLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	resendReturnLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	sendInvoice?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEngravingInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalSubmit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ObjectWithMetadataKeySpecifier = ('metadata' | 'metafield' | ObjectWithMetadataKeySpecifier)[];
export type ObjectWithMetadataFieldPolicy = {
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfflinePaymentConfirmResultKeySpecifier = ('errors' | OfflinePaymentConfirmResultKeySpecifier)[];
export type OfflinePaymentConfirmResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfflinePaymentEmailResultKeySpecifier = ('errors' | OfflinePaymentEmailResultKeySpecifier)[];
export type OfflinePaymentEmailResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OfflinePaymentToggleResultKeySpecifier = ('errors' | OfflinePaymentToggleResultKeySpecifier)[];
export type OfflinePaymentToggleResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderKeySpecifier = ('billingAddress' | 'businessId' | 'channel' | 'discounts' | 'hasEngraving' | 'hasRefund' | 'hasWarrantyExtension' | 'id' | 'isValid' | 'lines' | 'payPerLinkExpiration' | 'payPerLinkUrl' | 'payment' | 'paymentRequest' | 'preOrderDeposit' | 'preOrderDepositPercentage' | 'return' | 'shipping' | 'shippingAddress' | 'source' | 'status' | 'subscription' | 'type' | 'user' | 'userEmail' | OrderKeySpecifier)[];
export type OrderFieldPolicy = {
	billingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	businessId?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	discounts?: FieldPolicy<any> | FieldReadFunction<any>,
	hasEngraving?: FieldPolicy<any> | FieldReadFunction<any>,
	hasRefund?: FieldPolicy<any> | FieldReadFunction<any>,
	hasWarrantyExtension?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isValid?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	payPerLinkExpiration?: FieldPolicy<any> | FieldReadFunction<any>,
	payPerLinkUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	preOrderDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	preOrderDepositPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	return?: FieldPolicy<any> | FieldReadFunction<any>,
	shipping?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subscription?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userEmail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderAbandonResultKeySpecifier = ('errors' | 'newBusinessId' | OrderAbandonResultKeySpecifier)[];
export type OrderAbandonResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	newBusinessId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderCancelResultKeySpecifier = ('canceled' | 'errors' | 'order' | OrderCancelResultKeySpecifier)[];
export type OrderCancelResultFieldPolicy = {
	canceled?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderCreateResultKeySpecifier = ('errors' | 'order' | OrderCreateResultKeySpecifier)[];
export type OrderCreateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderDiscountKeySpecifier = ('amount' | 'id' | 'name' | 'reason' | 'type' | 'value' | 'valueType' | OrderDiscountKeySpecifier)[];
export type OrderDiscountFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	valueType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderDiscountAddResultKeySpecifier = ('errors' | 'order' | OrderDiscountAddResultKeySpecifier)[];
export type OrderDiscountAddResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderFreeShippingAddResultKeySpecifier = ('errors' | 'order' | OrderFreeShippingAddResultKeySpecifier)[];
export type OrderFreeShippingAddResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderGenerateBusinessIdResultKeySpecifier = ('businessId' | 'errors' | OrderGenerateBusinessIdResultKeySpecifier)[];
export type OrderGenerateBusinessIdResultFieldPolicy = {
	businessId?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderGenerateInvoiceResultKeySpecifier = ('errors' | OrderGenerateInvoiceResultKeySpecifier)[];
export type OrderGenerateInvoiceResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderGwpUpdateResultKeySpecifier = ('errors' | OrderGwpUpdateResultKeySpecifier)[];
export type OrderGwpUpdateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLineKeySpecifier = ('discounts' | 'hasWarrantyExtension' | 'id' | 'metadata' | 'quantity' | 'strapPackReference' | 'strapReference' | 'totalPrice' | 'undiscountedUnitPrice' | 'unitDiscount' | 'unitDiscountType' | 'unitDiscountValue' | 'unitPrice' | 'variant' | 'warrantyExtensionDuration' | 'warrantyExtensionId' | 'watchLineId' | OrderLineKeySpecifier)[];
export type OrderLineFieldPolicy = {
	discounts?: FieldPolicy<any> | FieldReadFunction<any>,
	hasWarrantyExtension?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	strapPackReference?: FieldPolicy<any> | FieldReadFunction<any>,
	strapReference?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	undiscountedUnitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDiscountType?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDiscountValue?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>,
	warrantyExtensionDuration?: FieldPolicy<any> | FieldReadFunction<any>,
	warrantyExtensionId?: FieldPolicy<any> | FieldReadFunction<any>,
	watchLineId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLineDeleteResultKeySpecifier = ('errors' | 'order' | OrderLineDeleteResultKeySpecifier)[];
export type OrderLineDeleteResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLineDiscountKeySpecifier = ('id' | 'name' | 'reason' | 'total' | 'translatedName' | 'type' | 'value' | 'valueType' | OrderLineDiscountKeySpecifier)[];
export type OrderLineDiscountFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	translatedName?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	valueType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLineDiscountRemoveKeySpecifier = ('errors' | 'order' | 'orderLine' | OrderLineDiscountRemoveKeySpecifier)[];
export type OrderLineDiscountRemoveFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLine?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLineDiscountUpdateResultKeySpecifier = ('errors' | 'order' | 'orderLine' | OrderLineDiscountUpdateResultKeySpecifier)[];
export type OrderLineDiscountUpdateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLine?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLinesCreateResultKeySpecifier = ('errors' | 'order' | OrderLinesCreateResultKeySpecifier)[];
export type OrderLinesCreateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderReturnCreateKeySpecifier = ('errors' | 'order' | OrderReturnCreateKeySpecifier)[];
export type OrderReturnCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderReturnRejectResultKeySpecifier = ('errors' | OrderReturnRejectResultKeySpecifier)[];
export type OrderReturnRejectResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderSendPaymentInvitationResultKeySpecifier = ('errors' | OrderSendPaymentInvitationResultKeySpecifier)[];
export type OrderSendPaymentInvitationResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderShippingAddressUpdateResultKeySpecifier = ('errors' | OrderShippingAddressUpdateResultKeySpecifier)[];
export type OrderShippingAddressUpdateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderUpdateClientDetailsResultKeySpecifier = ('errors' | OrderUpdateClientDetailsResultKeySpecifier)[];
export type OrderUpdateClientDetailsResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderValidationResultKeySpecifier = ('errors' | 'id' | 'valid' | OrderValidationResultKeySpecifier)[];
export type OrderValidationResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	valid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderValidationStatusKeySpecifier = ('message' | 'valid' | OrderValidationStatusKeySpecifier)[];
export type OrderValidationStatusFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	valid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderVoucherAddResultKeySpecifier = ('errors' | 'order' | OrderVoucherAddResultKeySpecifier)[];
export type OrderVoucherAddResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderVoucherDeleteResultKeySpecifier = ('errors' | 'order' | OrderVoucherDeleteResultKeySpecifier)[];
export type OrderVoucherDeleteResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayPerLinkOrderKeySpecifier = ('businessId' | 'channel' | 'expirationTimestamp' | 'id' | 'lines' | 'paymentRequest' | 'preOrderDeposit' | 'preOrderDepositPercentage' | 'shippingAddress' | 'shippingPrice' | 'subtotal' | 'total' | 'userEmail' | PayPerLinkOrderKeySpecifier)[];
export type PayPerLinkOrderFieldPolicy = {
	businessId?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	expirationTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	preOrderDeposit?: FieldPolicy<any> | FieldReadFunction<any>,
	preOrderDepositPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotal?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	userEmail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PayPerLinkOrderLineKeySpecifier = ('id' | 'isShippingRequired' | 'metadata' | 'productName' | 'productSku' | 'productVariantId' | 'quantity' | 'quantityFulfilled' | 'quantityToFulfill' | 'taxRate' | 'thumbnail' | 'totalPrice' | 'undiscountedUnitPrice' | 'unitDiscount' | 'unitDiscountReason' | 'unitDiscountType' | 'unitDiscountValue' | 'unitPrice' | 'variant' | 'variantName' | PayPerLinkOrderLineKeySpecifier)[];
export type PayPerLinkOrderLineFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isShippingRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>,
	productSku?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantId?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityFulfilled?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityToFulfill?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	undiscountedUnitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDiscountReason?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDiscountType?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDiscountValue?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>,
	variantName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentCaptureRetryResultKeySpecifier = ('errors' | PaymentCaptureRetryResultKeySpecifier)[];
export type PaymentCaptureRetryResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentProductKeySpecifier = ('category' | 'id' | 'metadata' | PaymentProductKeySpecifier)[];
export type PaymentProductFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentProductVariantKeySpecifier = ('id' | 'product' | PaymentProductVariantKeySpecifier)[];
export type PaymentProductVariantFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentRequestDataKeySpecifier = ('amount' | 'currency' | 'transactionType' | PaymentRequestDataKeySpecifier)[];
export type PaymentRequestDataFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PreOrderConfigKeySpecifier = ('availableFrom' | 'availableTo' | 'dedicatedStock' | 'deliveryDate' | 'depositPercentage' | 'forcePreOrder' | 'isInfiniteStock' | 'market' | 'notifyMe' | 'preOrder' | PreOrderConfigKeySpecifier)[];
export type PreOrderConfigFieldPolicy = {
	availableFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	availableTo?: FieldPolicy<any> | FieldReadFunction<any>,
	dedicatedStock?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	depositPercentage?: FieldPolicy<any> | FieldReadFunction<any>,
	forcePreOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	isInfiniteStock?: FieldPolicy<any> | FieldReadFunction<any>,
	market?: FieldPolicy<any> | FieldReadFunction<any>,
	notifyMe?: FieldPolicy<any> | FieldReadFunction<any>,
	preOrder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductKeySpecifier = ('attribute' | 'category' | 'id' | 'name' | 'productType' | 'thumbnail' | 'translation' | ProductKeySpecifier)[];
export type ProductFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductTranslationKeySpecifier = ('name' | ProductTranslationKeySpecifier)[];
export type ProductTranslationFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductTypeKeySpecifier = ('id' | 'name' | ProductTypeKeySpecifier)[];
export type ProductTypeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantKeySpecifier = ('id' | 'name' | 'preOrderQuantityAvailable' | 'product' | 'quantityAvailable' | 'sellable' | 'sku' | 'variantCTA' | ProductVariantKeySpecifier)[];
export type ProductVariantFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	preOrderQuantityAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	sellable?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	variantCTA?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantBulkUpdateResultKeySpecifier = ('errors' | 'results' | ProductVariantBulkUpdateResultKeySpecifier)[];
export type ProductVariantBulkUpdateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantUpdateResultKeySpecifier = ('errors' | 'preOrderConfig' | 'sku' | ProductVariantUpdateResultKeySpecifier)[];
export type ProductVariantUpdateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	preOrderConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantsWithPreOrderConfigKeySpecifier = ('defaultVisible' | 'marketSellable' | 'marketVisible' | 'phoneDefaultSellable' | 'preOrderConfig' | 'sku' | 'webDefaultSellable' | ProductVariantsWithPreOrderConfigKeySpecifier)[];
export type ProductVariantsWithPreOrderConfigFieldPolicy = {
	defaultVisible?: FieldPolicy<any> | FieldReadFunction<any>,
	marketSellable?: FieldPolicy<any> | FieldReadFunction<any>,
	marketVisible?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneDefaultSellable?: FieldPolicy<any> | FieldReadFunction<any>,
	preOrderConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	webDefaultSellable?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('billingCountries' | 'channelConfig' | 'checkout' | 'countriesChannels' | 'dynamicSetting' | 'gwpProducts' | 'order' | 'orderByPaymentToken' | 'orderIdByBusinessIdAndEmail' | 'productVariant' | 'productVariants' | 'productVariantsWithPreOrderConfig' | 'refundCalculateTax' | 'returnReasons' | 'storefrontOfflinePaymentAvailability' | 'validateCheckout' | 'validateOrder' | 'voucher' | 'withdrawalEligibility' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	billingCountries?: FieldPolicy<any> | FieldReadFunction<any>,
	channelConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	countriesChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	dynamicSetting?: FieldPolicy<any> | FieldReadFunction<any>,
	gwpProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderByPaymentToken?: FieldPolicy<any> | FieldReadFunction<any>,
	orderIdByBusinessIdAndEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariants?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantsWithPreOrderConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	refundCalculateTax?: FieldPolicy<any> | FieldReadFunction<any>,
	returnReasons?: FieldPolicy<any> | FieldReadFunction<any>,
	storefrontOfflinePaymentAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	validateCheckout?: FieldPolicy<any> | FieldReadFunction<any>,
	validateOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalEligibility?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefundCalculateTaxLineResultKeySpecifier = ('gross' | 'net' | 'orderLineId' | 'tax' | RefundCalculateTaxLineResultKeySpecifier)[];
export type RefundCalculateTaxLineResultFieldPolicy = {
	gross?: FieldPolicy<any> | FieldReadFunction<any>,
	net?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLineId?: FieldPolicy<any> | FieldReadFunction<any>,
	tax?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefundCalculateTaxResultKeySpecifier = ('refundLines' | RefundCalculateTaxResultKeySpecifier)[];
export type RefundCalculateTaxResultFieldPolicy = {
	refundLines?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefundCreateResultKeySpecifier = ('errors' | RefundCreateResultKeySpecifier)[];
export type RefundCreateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RerouteFulfillmentLocationResultKeySpecifier = ('errors' | 'success' | RerouteFulfillmentLocationResultKeySpecifier)[];
export type RerouteFulfillmentLocationResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResendReturnLabelResponseKeySpecifier = ('errors' | 'success' | ResendReturnLabelResponseKeySpecifier)[];
export type ResendReturnLabelResponseFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReturnReasonKeySpecifier = ('audiences' | 'id' | 'translations' | ReturnReasonKeySpecifier)[];
export type ReturnReasonFieldPolicy = {
	audiences?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	translations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReturnReasonTranslationKeySpecifier = ('languageCode' | 'value' | ReturnReasonTranslationKeySpecifier)[];
export type ReturnReasonTranslationFieldPolicy = {
	languageCode?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SelectedAttributeKeySpecifier = ('attribute' | 'values' | SelectedAttributeKeySpecifier)[];
export type SelectedAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendInvoiceResponseKeySpecifier = ('errors' | 'success' | SendInvoiceResponseKeySpecifier)[];
export type SendInvoiceResponseFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SettingKeySpecifier = ('modified' | 'modifiedBy' | 'name' | 'value' | SettingKeySpecifier)[];
export type SettingFieldPolicy = {
	modified?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SettingResultKeySpecifier = ('errors' | 'setting' | SettingResultKeySpecifier)[];
export type SettingResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	setting?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingUpdateResultKeySpecifier = ('errors' | 'order' | ShippingUpdateResultKeySpecifier)[];
export type ShippingUpdateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionUpdateResultKeySpecifier = ('errors' | 'order' | SubscriptionUpdateResultKeySpecifier)[];
export type SubscriptionUpdateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxedMoneyKeySpecifier = ('currency' | 'gross' | 'net' | 'tax' | TaxedMoneyKeySpecifier)[];
export type TaxedMoneyFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	gross?: FieldPolicy<any> | FieldReadFunction<any>,
	net?: FieldPolicy<any> | FieldReadFunction<any>,
	tax?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ThumbnailKeySpecifier = ('url' | ThumbnailKeySpecifier)[];
export type ThumbnailFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateEngravingInfoResultKeySpecifier = ('errors' | UpdateEngravingInfoResultKeySpecifier)[];
export type UpdateEngravingInfoResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateMetadataResultKeySpecifier = ('errors' | 'item' | UpdateMetadataResultKeySpecifier)[];
export type UpdateMetadataResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('addresses' | 'dateJoined' | 'email' | 'firstName' | 'id' | 'isActive' | 'lastName' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	dateJoined?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherObjectKeySpecifier = ('discountValueType' | 'type' | VoucherObjectKeySpecifier)[];
export type VoucherObjectFieldPolicy = {
	discountValueType?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WithdrawalCustomerKeySpecifier = ('email' | 'firstName' | 'lastName' | WithdrawalCustomerKeySpecifier)[];
export type WithdrawalCustomerFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WithdrawalEligibilityResultKeySpecifier = ('errors' | 'withdrawal' | WithdrawalEligibilityResultKeySpecifier)[];
export type WithdrawalEligibilityResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawal?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WithdrawalInfoKeySpecifier = ('accessMode' | 'code' | 'customer' | 'lines' | 'order' | WithdrawalInfoKeySpecifier)[];
export type WithdrawalInfoFieldPolicy = {
	accessMode?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WithdrawalLineKeySpecifier = ('disabledReasonCode' | 'eligibleQuantity' | 'orderLineId' | 'productName' | 'quantity' | 'referenceDate' | 'referenceDateSource' | 'sku' | 'status' | 'windowEndAt' | WithdrawalLineKeySpecifier)[];
export type WithdrawalLineFieldPolicy = {
	disabledReasonCode?: FieldPolicy<any> | FieldReadFunction<any>,
	eligibleQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLineId?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceDate?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceDateSource?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	windowEndAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WithdrawalOrderSummaryKeySpecifier = ('businessId' | 'channel' | 'createdAt' | 'id' | 'status' | WithdrawalOrderSummaryKeySpecifier)[];
export type WithdrawalOrderSummaryFieldPolicy = {
	businessId?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WithdrawalSubmitInfoKeySpecifier = ('code' | 'items' | 'submittedAt' | 'withdrawalRequestId' | WithdrawalSubmitInfoKeySpecifier)[];
export type WithdrawalSubmitInfoFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	submittedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalRequestId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WithdrawalSubmitLineKeySpecifier = ('comment' | 'orderLineId' | 'quantity' | 'reasonCode' | 'status' | 'translatedReason' | WithdrawalSubmitLineKeySpecifier)[];
export type WithdrawalSubmitLineFieldPolicy = {
	comment?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLineId?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	reasonCode?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	translatedReason?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WithdrawalSubmitResultKeySpecifier = ('errors' | 'withdrawalSubmit' | WithdrawalSubmitResultKeySpecifier)[];
export type WithdrawalSubmitResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	withdrawalSubmit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	Address?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressKeySpecifier | (() => undefined | AddressKeySpecifier),
		fields?: AddressFieldPolicy,
	},
	Attribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeKeySpecifier | (() => undefined | AttributeKeySpecifier),
		fields?: AttributeFieldPolicy,
	},
	AttributeValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueKeySpecifier | (() => undefined | AttributeValueKeySpecifier),
		fields?: AttributeValueFieldPolicy,
	},
	AttributeValueTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueTranslationKeySpecifier | (() => undefined | AttributeValueTranslationKeySpecifier),
		fields?: AttributeValueTranslationFieldPolicy,
	},
	BillingCountry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BillingCountryKeySpecifier | (() => undefined | BillingCountryKeySpecifier),
		fields?: BillingCountryFieldPolicy,
	},
	Category?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryKeySpecifier | (() => undefined | CategoryKeySpecifier),
		fields?: CategoryFieldPolicy,
	},
	Channel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelKeySpecifier | (() => undefined | ChannelKeySpecifier),
		fields?: ChannelFieldPolicy,
	},
	ChannelConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelConfigKeySpecifier | (() => undefined | ChannelConfigKeySpecifier),
		fields?: ChannelConfigFieldPolicy,
	},
	Checkout?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutKeySpecifier | (() => undefined | CheckoutKeySpecifier),
		fields?: CheckoutFieldPolicy,
	},
	CheckoutCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutCreateKeySpecifier | (() => undefined | CheckoutCreateKeySpecifier),
		fields?: CheckoutCreateFieldPolicy,
	},
	CheckoutCreateCheckout?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutCreateCheckoutKeySpecifier | (() => undefined | CheckoutCreateCheckoutKeySpecifier),
		fields?: CheckoutCreateCheckoutFieldPolicy,
	},
	CheckoutCreateUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutCreateUserKeySpecifier | (() => undefined | CheckoutCreateUserKeySpecifier),
		fields?: CheckoutCreateUserFieldPolicy,
	},
	CheckoutGwpUpdateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutGwpUpdateResultKeySpecifier | (() => undefined | CheckoutGwpUpdateResultKeySpecifier),
		fields?: CheckoutGwpUpdateResultFieldPolicy,
	},
	CheckoutLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutLineKeySpecifier | (() => undefined | CheckoutLineKeySpecifier),
		fields?: CheckoutLineFieldPolicy,
	},
	CheckoutLinesAddResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutLinesAddResultKeySpecifier | (() => undefined | CheckoutLinesAddResultKeySpecifier),
		fields?: CheckoutLinesAddResultFieldPolicy,
	},
	CheckoutLinesDeleteResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutLinesDeleteResultKeySpecifier | (() => undefined | CheckoutLinesDeleteResultKeySpecifier),
		fields?: CheckoutLinesDeleteResultFieldPolicy,
	},
	CheckoutShippingAddressUpdateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutShippingAddressUpdateResultKeySpecifier | (() => undefined | CheckoutShippingAddressUpdateResultKeySpecifier),
		fields?: CheckoutShippingAddressUpdateResultFieldPolicy,
	},
	CheckoutValidationResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutValidationResultKeySpecifier | (() => undefined | CheckoutValidationResultKeySpecifier),
		fields?: CheckoutValidationResultFieldPolicy,
	},
	CheckoutVoucherAddResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutVoucherAddResultKeySpecifier | (() => undefined | CheckoutVoucherAddResultKeySpecifier),
		fields?: CheckoutVoucherAddResultFieldPolicy,
	},
	CheckoutVoucherDeleteResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutVoucherDeleteResultKeySpecifier | (() => undefined | CheckoutVoucherDeleteResultKeySpecifier),
		fields?: CheckoutVoucherDeleteResultFieldPolicy,
	},
	CountryChannel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CountryChannelKeySpecifier | (() => undefined | CountryChannelKeySpecifier),
		fields?: CountryChannelFieldPolicy,
	},
	CountryDisplay?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CountryDisplayKeySpecifier | (() => undefined | CountryDisplayKeySpecifier),
		fields?: CountryDisplayFieldPolicy,
	},
	DeleteMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteMetadataKeySpecifier | (() => undefined | DeleteMetadataKeySpecifier),
		fields?: DeleteMetadataFieldPolicy,
	},
	DeliveryMethod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryMethodKeySpecifier | (() => undefined | DeliveryMethodKeySpecifier),
		fields?: DeliveryMethodFieldPolicy,
	},
	DeliveryModeUpdateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeliveryModeUpdateResultKeySpecifier | (() => undefined | DeliveryModeUpdateResultKeySpecifier),
		fields?: DeliveryModeUpdateResultFieldPolicy,
	},
	DraftOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderKeySpecifier | (() => undefined | DraftOrderKeySpecifier),
		fields?: DraftOrderFieldPolicy,
	},
	DraftOrderCompleteResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderCompleteResultKeySpecifier | (() => undefined | DraftOrderCompleteResultKeySpecifier),
		fields?: DraftOrderCompleteResultFieldPolicy,
	},
	DraftOrderCreateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderCreateResultKeySpecifier | (() => undefined | DraftOrderCreateResultKeySpecifier),
		fields?: DraftOrderCreateResultFieldPolicy,
	},
	Error?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ErrorKeySpecifier | (() => undefined | ErrorKeySpecifier),
		fields?: ErrorFieldPolicy,
	},
	GwpProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GwpProductKeySpecifier | (() => undefined | GwpProductKeySpecifier),
		fields?: GwpProductFieldPolicy,
	},
	IdOnlyOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IdOnlyOrderKeySpecifier | (() => undefined | IdOnlyOrderKeySpecifier),
		fields?: IdOnlyOrderFieldPolicy,
	},
	Image?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageKeySpecifier | (() => undefined | ImageKeySpecifier),
		fields?: ImageFieldPolicy,
	},
	MarketSellable?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarketSellableKeySpecifier | (() => undefined | MarketSellableKeySpecifier),
		fields?: MarketSellableFieldPolicy,
	},
	MarketVisible?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarketVisibleKeySpecifier | (() => undefined | MarketVisibleKeySpecifier),
		fields?: MarketVisibleFieldPolicy,
	},
	MetadataItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetadataItemKeySpecifier | (() => undefined | MetadataItemKeySpecifier),
		fields?: MetadataItemFieldPolicy,
	},
	Money?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoneyKeySpecifier | (() => undefined | MoneyKeySpecifier),
		fields?: MoneyFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	ObjectWithMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ObjectWithMetadataKeySpecifier | (() => undefined | ObjectWithMetadataKeySpecifier),
		fields?: ObjectWithMetadataFieldPolicy,
	},
	OfflinePaymentConfirmResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfflinePaymentConfirmResultKeySpecifier | (() => undefined | OfflinePaymentConfirmResultKeySpecifier),
		fields?: OfflinePaymentConfirmResultFieldPolicy,
	},
	OfflinePaymentEmailResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfflinePaymentEmailResultKeySpecifier | (() => undefined | OfflinePaymentEmailResultKeySpecifier),
		fields?: OfflinePaymentEmailResultFieldPolicy,
	},
	OfflinePaymentToggleResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OfflinePaymentToggleResultKeySpecifier | (() => undefined | OfflinePaymentToggleResultKeySpecifier),
		fields?: OfflinePaymentToggleResultFieldPolicy,
	},
	Order?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderKeySpecifier | (() => undefined | OrderKeySpecifier),
		fields?: OrderFieldPolicy,
	},
	OrderAbandonResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderAbandonResultKeySpecifier | (() => undefined | OrderAbandonResultKeySpecifier),
		fields?: OrderAbandonResultFieldPolicy,
	},
	OrderCancelResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderCancelResultKeySpecifier | (() => undefined | OrderCancelResultKeySpecifier),
		fields?: OrderCancelResultFieldPolicy,
	},
	OrderCreateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderCreateResultKeySpecifier | (() => undefined | OrderCreateResultKeySpecifier),
		fields?: OrderCreateResultFieldPolicy,
	},
	OrderDiscount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderDiscountKeySpecifier | (() => undefined | OrderDiscountKeySpecifier),
		fields?: OrderDiscountFieldPolicy,
	},
	OrderDiscountAddResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderDiscountAddResultKeySpecifier | (() => undefined | OrderDiscountAddResultKeySpecifier),
		fields?: OrderDiscountAddResultFieldPolicy,
	},
	OrderFreeShippingAddResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderFreeShippingAddResultKeySpecifier | (() => undefined | OrderFreeShippingAddResultKeySpecifier),
		fields?: OrderFreeShippingAddResultFieldPolicy,
	},
	OrderGenerateBusinessIdResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderGenerateBusinessIdResultKeySpecifier | (() => undefined | OrderGenerateBusinessIdResultKeySpecifier),
		fields?: OrderGenerateBusinessIdResultFieldPolicy,
	},
	OrderGenerateInvoiceResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderGenerateInvoiceResultKeySpecifier | (() => undefined | OrderGenerateInvoiceResultKeySpecifier),
		fields?: OrderGenerateInvoiceResultFieldPolicy,
	},
	OrderGwpUpdateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderGwpUpdateResultKeySpecifier | (() => undefined | OrderGwpUpdateResultKeySpecifier),
		fields?: OrderGwpUpdateResultFieldPolicy,
	},
	OrderLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLineKeySpecifier | (() => undefined | OrderLineKeySpecifier),
		fields?: OrderLineFieldPolicy,
	},
	OrderLineDeleteResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLineDeleteResultKeySpecifier | (() => undefined | OrderLineDeleteResultKeySpecifier),
		fields?: OrderLineDeleteResultFieldPolicy,
	},
	OrderLineDiscount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLineDiscountKeySpecifier | (() => undefined | OrderLineDiscountKeySpecifier),
		fields?: OrderLineDiscountFieldPolicy,
	},
	OrderLineDiscountRemove?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLineDiscountRemoveKeySpecifier | (() => undefined | OrderLineDiscountRemoveKeySpecifier),
		fields?: OrderLineDiscountRemoveFieldPolicy,
	},
	OrderLineDiscountUpdateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLineDiscountUpdateResultKeySpecifier | (() => undefined | OrderLineDiscountUpdateResultKeySpecifier),
		fields?: OrderLineDiscountUpdateResultFieldPolicy,
	},
	OrderLinesCreateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLinesCreateResultKeySpecifier | (() => undefined | OrderLinesCreateResultKeySpecifier),
		fields?: OrderLinesCreateResultFieldPolicy,
	},
	OrderReturnCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderReturnCreateKeySpecifier | (() => undefined | OrderReturnCreateKeySpecifier),
		fields?: OrderReturnCreateFieldPolicy,
	},
	OrderReturnRejectResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderReturnRejectResultKeySpecifier | (() => undefined | OrderReturnRejectResultKeySpecifier),
		fields?: OrderReturnRejectResultFieldPolicy,
	},
	OrderSendPaymentInvitationResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderSendPaymentInvitationResultKeySpecifier | (() => undefined | OrderSendPaymentInvitationResultKeySpecifier),
		fields?: OrderSendPaymentInvitationResultFieldPolicy,
	},
	OrderShippingAddressUpdateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderShippingAddressUpdateResultKeySpecifier | (() => undefined | OrderShippingAddressUpdateResultKeySpecifier),
		fields?: OrderShippingAddressUpdateResultFieldPolicy,
	},
	OrderUpdateClientDetailsResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderUpdateClientDetailsResultKeySpecifier | (() => undefined | OrderUpdateClientDetailsResultKeySpecifier),
		fields?: OrderUpdateClientDetailsResultFieldPolicy,
	},
	OrderValidationResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderValidationResultKeySpecifier | (() => undefined | OrderValidationResultKeySpecifier),
		fields?: OrderValidationResultFieldPolicy,
	},
	OrderValidationStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderValidationStatusKeySpecifier | (() => undefined | OrderValidationStatusKeySpecifier),
		fields?: OrderValidationStatusFieldPolicy,
	},
	OrderVoucherAddResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderVoucherAddResultKeySpecifier | (() => undefined | OrderVoucherAddResultKeySpecifier),
		fields?: OrderVoucherAddResultFieldPolicy,
	},
	OrderVoucherDeleteResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderVoucherDeleteResultKeySpecifier | (() => undefined | OrderVoucherDeleteResultKeySpecifier),
		fields?: OrderVoucherDeleteResultFieldPolicy,
	},
	PayPerLinkOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayPerLinkOrderKeySpecifier | (() => undefined | PayPerLinkOrderKeySpecifier),
		fields?: PayPerLinkOrderFieldPolicy,
	},
	PayPerLinkOrderLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PayPerLinkOrderLineKeySpecifier | (() => undefined | PayPerLinkOrderLineKeySpecifier),
		fields?: PayPerLinkOrderLineFieldPolicy,
	},
	PaymentCaptureRetryResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentCaptureRetryResultKeySpecifier | (() => undefined | PaymentCaptureRetryResultKeySpecifier),
		fields?: PaymentCaptureRetryResultFieldPolicy,
	},
	PaymentProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentProductKeySpecifier | (() => undefined | PaymentProductKeySpecifier),
		fields?: PaymentProductFieldPolicy,
	},
	PaymentProductVariant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentProductVariantKeySpecifier | (() => undefined | PaymentProductVariantKeySpecifier),
		fields?: PaymentProductVariantFieldPolicy,
	},
	PaymentRequestData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentRequestDataKeySpecifier | (() => undefined | PaymentRequestDataKeySpecifier),
		fields?: PaymentRequestDataFieldPolicy,
	},
	PreOrderConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PreOrderConfigKeySpecifier | (() => undefined | PreOrderConfigKeySpecifier),
		fields?: PreOrderConfigFieldPolicy,
	},
	Product?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductKeySpecifier | (() => undefined | ProductKeySpecifier),
		fields?: ProductFieldPolicy,
	},
	ProductTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductTranslationKeySpecifier | (() => undefined | ProductTranslationKeySpecifier),
		fields?: ProductTranslationFieldPolicy,
	},
	ProductType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductTypeKeySpecifier | (() => undefined | ProductTypeKeySpecifier),
		fields?: ProductTypeFieldPolicy,
	},
	ProductVariant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantKeySpecifier | (() => undefined | ProductVariantKeySpecifier),
		fields?: ProductVariantFieldPolicy,
	},
	ProductVariantBulkUpdateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantBulkUpdateResultKeySpecifier | (() => undefined | ProductVariantBulkUpdateResultKeySpecifier),
		fields?: ProductVariantBulkUpdateResultFieldPolicy,
	},
	ProductVariantUpdateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantUpdateResultKeySpecifier | (() => undefined | ProductVariantUpdateResultKeySpecifier),
		fields?: ProductVariantUpdateResultFieldPolicy,
	},
	ProductVariantsWithPreOrderConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantsWithPreOrderConfigKeySpecifier | (() => undefined | ProductVariantsWithPreOrderConfigKeySpecifier),
		fields?: ProductVariantsWithPreOrderConfigFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	RefundCalculateTaxLineResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefundCalculateTaxLineResultKeySpecifier | (() => undefined | RefundCalculateTaxLineResultKeySpecifier),
		fields?: RefundCalculateTaxLineResultFieldPolicy,
	},
	RefundCalculateTaxResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefundCalculateTaxResultKeySpecifier | (() => undefined | RefundCalculateTaxResultKeySpecifier),
		fields?: RefundCalculateTaxResultFieldPolicy,
	},
	RefundCreateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefundCreateResultKeySpecifier | (() => undefined | RefundCreateResultKeySpecifier),
		fields?: RefundCreateResultFieldPolicy,
	},
	RerouteFulfillmentLocationResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RerouteFulfillmentLocationResultKeySpecifier | (() => undefined | RerouteFulfillmentLocationResultKeySpecifier),
		fields?: RerouteFulfillmentLocationResultFieldPolicy,
	},
	ResendReturnLabelResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResendReturnLabelResponseKeySpecifier | (() => undefined | ResendReturnLabelResponseKeySpecifier),
		fields?: ResendReturnLabelResponseFieldPolicy,
	},
	ReturnReason?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReturnReasonKeySpecifier | (() => undefined | ReturnReasonKeySpecifier),
		fields?: ReturnReasonFieldPolicy,
	},
	ReturnReasonTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReturnReasonTranslationKeySpecifier | (() => undefined | ReturnReasonTranslationKeySpecifier),
		fields?: ReturnReasonTranslationFieldPolicy,
	},
	SelectedAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SelectedAttributeKeySpecifier | (() => undefined | SelectedAttributeKeySpecifier),
		fields?: SelectedAttributeFieldPolicy,
	},
	SendInvoiceResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendInvoiceResponseKeySpecifier | (() => undefined | SendInvoiceResponseKeySpecifier),
		fields?: SendInvoiceResponseFieldPolicy,
	},
	Setting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SettingKeySpecifier | (() => undefined | SettingKeySpecifier),
		fields?: SettingFieldPolicy,
	},
	SettingResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SettingResultKeySpecifier | (() => undefined | SettingResultKeySpecifier),
		fields?: SettingResultFieldPolicy,
	},
	ShippingUpdateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingUpdateResultKeySpecifier | (() => undefined | ShippingUpdateResultKeySpecifier),
		fields?: ShippingUpdateResultFieldPolicy,
	},
	SubscriptionUpdateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionUpdateResultKeySpecifier | (() => undefined | SubscriptionUpdateResultKeySpecifier),
		fields?: SubscriptionUpdateResultFieldPolicy,
	},
	TaxedMoney?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxedMoneyKeySpecifier | (() => undefined | TaxedMoneyKeySpecifier),
		fields?: TaxedMoneyFieldPolicy,
	},
	Thumbnail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ThumbnailKeySpecifier | (() => undefined | ThumbnailKeySpecifier),
		fields?: ThumbnailFieldPolicy,
	},
	UpdateEngravingInfoResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateEngravingInfoResultKeySpecifier | (() => undefined | UpdateEngravingInfoResultKeySpecifier),
		fields?: UpdateEngravingInfoResultFieldPolicy,
	},
	UpdateMetadataResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateMetadataResultKeySpecifier | (() => undefined | UpdateMetadataResultKeySpecifier),
		fields?: UpdateMetadataResultFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	VoucherObject?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherObjectKeySpecifier | (() => undefined | VoucherObjectKeySpecifier),
		fields?: VoucherObjectFieldPolicy,
	},
	WithdrawalCustomer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WithdrawalCustomerKeySpecifier | (() => undefined | WithdrawalCustomerKeySpecifier),
		fields?: WithdrawalCustomerFieldPolicy,
	},
	WithdrawalEligibilityResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WithdrawalEligibilityResultKeySpecifier | (() => undefined | WithdrawalEligibilityResultKeySpecifier),
		fields?: WithdrawalEligibilityResultFieldPolicy,
	},
	WithdrawalInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WithdrawalInfoKeySpecifier | (() => undefined | WithdrawalInfoKeySpecifier),
		fields?: WithdrawalInfoFieldPolicy,
	},
	WithdrawalLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WithdrawalLineKeySpecifier | (() => undefined | WithdrawalLineKeySpecifier),
		fields?: WithdrawalLineFieldPolicy,
	},
	WithdrawalOrderSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WithdrawalOrderSummaryKeySpecifier | (() => undefined | WithdrawalOrderSummaryKeySpecifier),
		fields?: WithdrawalOrderSummaryFieldPolicy,
	},
	WithdrawalSubmitInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WithdrawalSubmitInfoKeySpecifier | (() => undefined | WithdrawalSubmitInfoKeySpecifier),
		fields?: WithdrawalSubmitInfoFieldPolicy,
	},
	WithdrawalSubmitLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WithdrawalSubmitLineKeySpecifier | (() => undefined | WithdrawalSubmitLineKeySpecifier),
		fields?: WithdrawalSubmitLineFieldPolicy,
	},
	WithdrawalSubmitResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WithdrawalSubmitResultKeySpecifier | (() => undefined | WithdrawalSubmitResultKeySpecifier),
		fields?: WithdrawalSubmitResultFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;